import React, { useEffect, useState, useRef } from "react";
import Layout from "../../layout/default";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Card,
  CardBody,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  Input,
  Select,
  Stack,
  Text,
  Tooltip,
  useToast,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  UnorderedList,
  ListItem,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  AlertDialog,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogOverlay,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  Checkbox,
  CheckboxGroup,
  HStack,
  Tag,
  Radio,
  RadioGroup,
  VStack,
} from "@chakra-ui/react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaExternalLinkAlt } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";
import axios from "axios";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import Seo, { schema } from "../../utilities/Seo";

const proficiencyLevelOption = [
  { id: 0, name: "Beginner", value: "beginner" },
  { id: 1, name: "Intermediate", value: "intermediate" },
  { id: 2, name: "Advance", value: "advance" },
];

const CourseUpdate = ({ courseData, renderMe }) => {
  const [selectedImages, setSelectedImages] = useState(
    courseData?.images || []
  );
  const isInitialLoad = useRef(true);
  const [selectedImagesError, setSelectedImagesError] = useState(false);
  const [courseName, setCourseName] = useState(courseData?.courseName || "");
  const [courseNameError, setCourseNameError] = useState(false);
  const [isItCamp, setIsItCamp] = useState(courseData?.camp ? true : false);
  const [campName, setCampName] = useState(courseData?.campName || "");
  const [campNameError, setCampNameError] = useState(false);
  const [maximumGroupSize, setMaximumGroupSize] = useState(
    courseData?.maxGroupSize || 1
  );
  const [maximumGroupSizeError, setMaximumGroupSizeError] = useState(false);
  const [sessionType, setSessionType] = useState(
    courseData?.sessionType?.toLowerCase() || "group"
  );
  const [categoryType, setCategoryType] = useState(courseData?.category || "");
  const [categories, setCategories] = useState([]);
  const [courseDescription, setCourseDescription] = useState(
    courseData?.description || ""
  );
  const [isCustomImage, setIsCustomImage] = useState(
    courseData?.customImage || false
  );
  const [courseDescriptionError, setCourseDescriptionError] = useState(false);
  const [courseAmeneties, setCourseAmeneties] = useState(
    courseData?.amenitiesProvided || ""
  );
  const [btnIsLoading, setBtnIsLoading] = useState(false);
  const [facilities, setFacilities] = useState([]);
  const [selectedDays, setSelectedDays] = useState(
    courseData?.dates?.days || []
  );
  const [isEnd, setIsEnd] = useState(false);
  const [timeFrom, setTimeFrom] = useState("");
  const [timeTo, setTimeTo] = useState("");
  const [timingMode, setTimingMode] = useState(courseData?.dates?.timingMode || "same");
  const [daySchedules, setDaySchedules] = useState([]);
  const [daySchedulesError, setDaySchedulesError] = useState(false);
  const [classType, setClassType] = useState(courseData?.classType || "class");

  const parseIsoToLocalDateOnly = (value) => {
    if (!value) return "";
    const isoString = typeof value === "string" ? value : value.toString();
    const datePart = isoString.slice(0, 10);
    const parts = datePart.split("-");
    if (parts.length !== 3) return "";
    const [year, month, day] = parts.map((p) => Number(p));
    if (!year || !month || !day) return "";
    return new Date(year, month - 1, day);
  };

  const [startDate, setStartDate] = useState(
    courseData?.dates?.startDate ? parseIsoToLocalDateOnly(courseData.dates.startDate) : ""
  );
  const [startDateError, setStartDateError] = useState(false);
  const [endDate, setEndDate] = useState(
    courseData?.dates?.endDate ? parseIsoToLocalDateOnly(courseData.dates.endDate) : ""
  );
  const [endDateError, setEndDateError] = useState(false);

  const [price, setPrice] = useState(courseData?.fees?.feesCourse || "");
  const [priceError, setPriceError] = useState(false);
  const [fees30, setFees30] = useState(courseData?.fees?.fees30 || "");
  const [fees45, setFees45] = useState(courseData?.fees?.fees45 || "");
  const [fees60, setFees60] = useState(courseData?.fees?.fees60 || "");
  const [fees30Error, setFees30Error] = useState(false);
  const [fees45Error, setFees45Error] = useState(false);
  const [fees60Error, setFees60Error] = useState(false);
  const [cancellationPolicy, setCancellationPolicy] = useState(
    courseData?.cancellationPolicy || ""
  );
  const [carryThings, setCarryThings] = useState(
    courseData?.whatYouHaveToBring || ""
  );
  const [timeFromError, setTimeFromError] = useState(false);
  const [timeToError, setTimeToError] = useState(false);
  const [courseFacility, setCourseFacility] = useState(
    courseData?.facility?.name || ""
  );
  const [categoryError, setCategoryError] = useState(false);
  const [facilityError, setFacilityError] = useState(false);
  const [selectedDaysError, setSelectedDaysError] = useState(false);
  const [coach, setCoach] = useState({});
  const [proficiencyLevel, setProficiencyLevel] = useState(courseData?.proficiency || []);
  const [isProficiencyMenuOpen, setIsProficiencyMenuOpen] = useState(false);
  const [showSlotConflict, setShowSlotConflict] = useState(false);
  const [conflictResult, setConflictResult] = useState({});
  const [academyStartTime, setAcademyStartTime] = useState(null);
  const [academyEndTime, setAcademyEndTime] = useState(null);
  const [isDiscardDisabled, setIsDiscardDisabled] = useState(false);
  const [formChanged, setFormChanged] = useState(false);
  const initialValuesRef = useRef(null);
  const [priceFieldsEnabled, setPriceFieldsEnabled] = useState({
    price30: false,
    price45: false,
    price60: false,
    coursePrice: false
  });

  const feeCacheRef = useRef({
    fees30: courseData?.fees?.fees30 || "",
    fees45: courseData?.fees?.fees45 || "",
    fees60: courseData?.fees?.fees60 || "",
    price: courseData?.fees?.feesCourse || "",
  });

  const [courseBookings, setCourseBookings] = useState([]);
  const [bookingsLoading, setBookingsLoading] = useState(false);
  const [hasFutureBookings, setHasFutureBookings] = useState(false);
  const [bookingTimeConflicts, setBookingTimeConflicts] = useState([]);
  const [showBookingTimeConflict, setShowBookingTimeConflict] = useState(false);
  const [courseStarted, setCourseStarted] = useState(false);

  const handleFormChange = () => {
    setFormChanged(true);
    setIsDiscardDisabled(false);
  };

  // Calculate minutes difference between start and end time
  const calculateMinutesDifference = (startTime, endTime) => {
    if (!startTime || !endTime) return 0;
    const start = new Date(startTime);
    const end = new Date(endTime);
    const startMinutes = start.getHours() * 60 + start.getMinutes();
    const endMinutes = end.getHours() * 60 + end.getMinutes();
    let diff = endMinutes - startMinutes;
    if (diff < 0) diff += 24 * 60;
    return diff;
  };

  const handleStateUpdate = () => {
    const updatedProficiencies = proficiencyLevelOption
      .filter((x) => courseData?.proficiency?.includes(x.value))
      .map((x) => x.value);

    setProficiencyLevel(updatedProficiencies);
  };
  useEffect(() => {
    handleStateUpdate();
  }, [courseData]);

  useEffect(() => {
    let minutesDiff = 0;
    if (timingMode === "same") {
      minutesDiff = calculateMinutesDifference(timeFrom, timeTo);
    } else if (timingMode === "different" && daySchedules.length > 0) {
      const durations = daySchedules
        .filter((s) => s.startTime && s.endTime)
        .map((s) => calculateMinutesDifference(s.startTime, s.endTime));
      minutesDiff = durations.length > 0 ? Math.max(...durations) : 0;
    }
    const enabledFields = {
      price30: minutesDiff >= 30,
      price45: minutesDiff >= 45,
      price60: minutesDiff >= 60,
      coursePrice: minutesDiff >= 30 && (timingMode === "same" ? timeTo !== "" : daySchedules.some((s) => s.startTime && s.endTime)),
    };
    setPriceFieldsEnabled(enabledFields);

    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    const cache = feeCacheRef.current;

    const syncCachedField = (key, enabled, currentValue, setValue, clearError) => {
      if (!enabled) {
        if (currentValue !== "") {
          cache[key] = currentValue;
          setValue("");
        }
        clearError(false);
        return;
      }

      if (currentValue !== "") {
        cache[key] = currentValue;
        return;
      }
      if (cache[key] !== "") {
        setValue(cache[key]);
      }
    };

    if (classType === "class") {
      syncCachedField("fees30", enabledFields.price30, fees30, setFees30, setFees30Error);
      syncCachedField("fees45", enabledFields.price45, fees45, setFees45, setFees45Error);
      syncCachedField("fees60", enabledFields.price60, fees60, setFees60, setFees60Error);
    } else {
      syncCachedField("price", enabledFields.coursePrice, price, setPrice, setPriceError);
    }
  }, [timeFrom, timeTo, classType, timingMode, daySchedules]);

  function formatDateToYYYYMMDD(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2); // Add leading zero if needed
    const day = `0${date.getDate()}`.slice(-2); // Add leading zero if needed

    return `${year}-${month}-${day}`;
  }

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure();

  const setTimeField = (date, time) => {
    if (!date || !time) return null;
    const value = new Date(formatDateToYYYYMMDD(date)); // Your time value
    const [hours, minutes] = time.split(":");
    value.setHours(Number(hours)); // Set the hours
    value.setMinutes(Number(minutes) || 0); // Set the minutes
    return value;
  };

  const toast = useToast();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = sessionStorage.getItem("admintoken").split(" ")[1];

  // Toast management to prevent multiple toasts
  const activeToastRef = useRef(null);

  const showToast = (title, description, status = "error", duration = 4000) => {
    // Close any existing toast
    if (activeToastRef.current) {
      toast.close(activeToastRef.current);
    }

    // Show new toast and store its ID
    activeToastRef.current = toast({
      title,
      description,
      status,
      duration,
      position: "top",
      isClosable: true,
      onCloseComplete: () => {
        activeToastRef.current = null;
      },
    });
  };
  const userData = useSelector((state) => state.user);
  const hasBookings = courseData?.playerEnrolled > 0;

  const canWriteCourse = !!userData?.accessScopes?.course?.includes("write");
  const isSessionType = classType === "class";
  const isCourseType = classType === "course";

  const isTimeOnlyEditMode = canWriteCourse && hasFutureBookings && isSessionType;
  const isNoEditMode = canWriteCourse && hasFutureBookings && !isSessionType;
  const canEditAllFields = canWriteCourse && !hasFutureBookings;
  const canEditTimeFields = canWriteCourse && (!hasFutureBookings || isSessionType);
  const canEditDaysFields = canWriteCourse && (!hasFutureBookings || isSessionType);

  useEffect(() => {
    const fetchCourseBookings = async () => {
      if (!courseData?._id) return;
      setBookingsLoading(true);
      try {
        const resp = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/booking/?courseId=${courseData._id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const bookings = resp.data?.data || resp.data?.result || [];
        setCourseBookings(bookings);

        const now = moment().tz("Asia/Kolkata");

        const futureExists = bookings.some((b) => {
          return (b.classes || []).some((cl) => {
            if (!cl.date) return false;
            if (cl.status === "cancelled") return false;

            const datePart = moment(cl.date).format("YYYY-MM-DD");
            const endTime = cl.endTime || "00:00";

            const classEnd = moment.tz(
              `${datePart}T${endTime}`,
              "YYYY-MM-DDTHH:mm",
              "Asia/Kolkata"
            );

            return classEnd.isAfter(now);
          });
        });
        setHasFutureBookings(futureExists);
      } catch (error) {
        console.log("Error fetching course bookings:", error);
      } finally {
        setBookingsLoading(false);
      }
    };

    fetchCourseBookings();
  }, [courseData?._id]);

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  // Get available days from coach's academy availability
  const getAvailableDays = () => {
    if (coach?.academyAvailability?.days && coach.academyAvailability.days.length > 0) {
      return coach.academyAvailability.days;
    }
    return days; // fallback to all days if no restriction
  };

  const availableDays = getAvailableDays();

  // Get date range restrictions from coach's academy availability
  const getDateRestrictions = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to start of day for accurate comparison

    if (coach?.academyAvailability?.startDate && coach?.academyAvailability?.endDate) {
      const coachStartDate = new Date(coach.academyAvailability.startDate);
      const coachEndDate = new Date(coach.academyAvailability.endDate);

      return {
        minDate: coachStartDate > today ? coachStartDate : today, // Use whichever is later
        maxDate: coachEndDate
      };
    }
    return {
      minDate: today, // Always start from today, never allow past dates
      maxDate: null // No max date restriction
    };
  };

  const dateRestrictions = getDateRestrictions();

  const getCurrentTime = () => {
    const currentDate = new Date();
    const currentHours = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    return new Date(0, 0, 0, currentHours, currentMinutes);
  };

  const currentTime = getCurrentTime();

  const date = new Date(startDate);
  const today = new Date();

  const includesToday =
    date.getDate() <= today.getDate() &&
    date.getMonth() <= today.getMonth() &&
    date.getFullYear() <= today.getFullYear();

  useEffect(() => {
    const checkStarted = () => {
      if (!startDate || !timeFrom) {
        setCourseStarted(false);
        return;
      }
      try {
        const startDt = new Date(`${formatDateToYYYYMMDD(startDate)}T${getTime(timeFrom)}:00`);
        setCourseStarted(startDt <= new Date());
      } catch (e) {
        setCourseStarted(false);
      }
    };

    checkStarted();
    const t = setInterval(checkStarted, 15000);
    return () => clearInterval(t);
  }, [startDate, timeFrom]);

  // const filterPassedTime = (time) => {
  //   if (!timeFrom) return true;
  //   const selectedTime = new Date(time);
  //   const minAllowedTime = getMinTime();
  //   return selectedTime >= minAllowedTime;
  // };

  const minTime = includesToday ? currentTime : undefined;

  const toMinutes = (d) => {
    const date = new Date(d);
    return date.getHours() * 60 + date.getMinutes();
  };

  const getMinTime = () => {
    if (timeFrom) {
      const selectedTime = new Date(timeFrom);
      // Add 30 minutes to the start time as minimum end time
      selectedTime.setMinutes(selectedTime.getMinutes() + 30);
      return selectedTime;
    }
    return academyStartTime || new Date(0, 0, 0, 0, 0);
  };

  // Use minute-based comparisons to avoid mismatches from different date components
  const filterTimeForStart = (time) => {
    const selectedMinutes = toMinutes(time);

    // If start date is today, don't allow past times
    if (startDate) {
      const today = new Date();
      const isToday = startDate.toDateString() === today.toDateString();
      if (isToday) {
        const nowMinutes = today.getHours() * 60 + today.getMinutes();
        if (selectedMinutes < nowMinutes) return false;
      }
    }

    // If academy times aren't set, allow any time (after current time if today)
    if (!academyStartTime || !academyEndTime) {
      return true;
    }

    const academyStartMinutes = toMinutes(academyStartTime);
    const academyEndMinutes = toMinutes(academyEndTime);

    // If start date is today, ensure selected time is after now and within academy hours
    if (startDate) {
      const today = new Date();
      const isToday = startDate.toDateString() === today.toDateString();
      if (isToday) {
        const nowMinutes = today.getHours() * 60 + today.getMinutes();
        return selectedMinutes >= nowMinutes && selectedMinutes >= academyStartMinutes && selectedMinutes <= academyEndMinutes;
      }
    }

    // For future dates, allow any time within academy hours
    return selectedMinutes >= academyStartMinutes && selectedMinutes <= academyEndMinutes;
  };

  const filterTimeForEnd = (time) => {
    const selectedMinutes = toMinutes(time);

    // If no start time is selected, allow any time within academy hours
    if (!timeFrom) {
      if (!academyStartTime || !academyEndTime) return true;
      const academyStartMinutes = toMinutes(academyStartTime);
      const academyEndMinutes = toMinutes(academyEndTime);
      return selectedMinutes >= academyStartMinutes && selectedMinutes <= academyEndMinutes;
    }

    const startMinutes = toMinutes(timeFrom);
    const minAllowedMinutes = startMinutes + 30; // 30-minute minimum

    if (!academyStartTime || !academyEndTime) {
      return selectedMinutes >= minAllowedMinutes;
    }

    const academyStartMinutes = toMinutes(academyStartTime);
    const academyEndMinutes = toMinutes(academyEndTime);

    const effectiveMin = Math.max(minAllowedMinutes, academyStartMinutes);
    return selectedMinutes >= effectiveMin && selectedMinutes <= academyEndMinutes;
  };

  const filterTimeForStartPerDay = (schedule, time) => {
    const selectedMinutes = toMinutes(time);

    if (!academyStartTime || !academyEndTime) return true;

    const academyStartMinutes = toMinutes(academyStartTime);
    const academyEndMinutes = toMinutes(academyEndTime);

    if (startDate && schedule?.day) {
      const today = new Date();
      const isStartDateToday = startDate.toDateString() === today.toDateString();

      if (isStartDateToday) {
        const weekdayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const todayLabel = weekdayLabels[today.getDay()];

        if (schedule.day === todayLabel) {
          const nowMinutes = today.getHours() * 60 + today.getMinutes();
          return selectedMinutes >= nowMinutes && selectedMinutes >= academyStartMinutes && selectedMinutes <= academyEndMinutes;
        }
      }
    }

    return selectedMinutes >= academyStartMinutes && selectedMinutes <= academyEndMinutes;
  };

  function daysDifference(startDate, endDate, daysArray) {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const start = new Date(startDate);
    const end = new Date(endDate);

    let count = 0;
    let currentDate = new Date(start);

    while (currentDate <= end) {
      if (daysArray.includes(daysOfWeek[currentDate.getDay()])) {
        count++;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return count;
  }

  function getLastDateOfCurrentYear() {
    var today = new Date(); // Get current date
    var currentYear = today.getFullYear(); // Get current year
    var lastDate = new Date(currentYear, 11, 31); // Set to December 31st of the current year
    return formatDateToYYYYMMDD(lastDate);
  }

  const isCoachEndDateSpecific = () => {
    if (!coach?.academyAvailability?.endDate || !coach?.academyAvailability?.startDate) {
      return false;
    }
    
    const coachStartDate = new Date(coach.academyAvailability.startDate);
    const coachEndDate = new Date(coach.academyAvailability.endDate);
    const yearsDifference = (coachEndDate - coachStartDate) / (1000 * 60 * 60 * 24 * 365.25);
    return yearsDifference < 9.5 || yearsDifference > 10.5;
  };

  const getTime = (time) => {
    const tempdate = new Date(time);

    const hours = tempdate.getHours(); // Get the hour component (0-23)
    const minutes = tempdate.getMinutes(); // Get the minute component (0-59)

    // Format the time as needed (e.g., to a string with leading zeros)
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;

    return formattedTime;
  };

  const timeStringToMinutes = (hhmm) => {
    if (!hhmm || typeof hhmm !== "string") return null;
    const parts = hhmm.split(":");
    const h = parseInt(parts[0], 10);
    const m = parts[1] ? parseInt(parts[1], 10) : 0;
    if (Number.isNaN(h) || Number.isNaN(m)) return null;
    return h * 60 + m;
  };

  const computeBookingWindowConflicts = (bookings, from, to, daySchedulesParam) => {
    if (!Array.isArray(bookings) || bookings.length === 0) return [];
    const usePerDay = Array.isArray(daySchedulesParam) && daySchedulesParam.length > 0;
    if (!usePerDay && (!from || !to)) return [];

    const getWindowForClass = (cl) => {
      if (usePerDay) {
        const day = cl.days || moment(cl.date).tz("Asia/Kolkata").format("ddd");
        const sched = daySchedulesParam.find((s) => s.day === day);
        if (!sched || !sched.startTime || !sched.endTime) return null;
        const windowStart = timeStringToMinutes(typeof sched.startTime === "object" && sched.startTime instanceof Date ? getTime(sched.startTime) : sched.startTime);
        let windowEnd = timeStringToMinutes(typeof sched.endTime === "object" && sched.endTime instanceof Date ? getTime(sched.endTime) : sched.endTime);
        if (windowStart === null || windowEnd === null) return null;
        if (windowEnd < windowStart) windowEnd += 24 * 60;
        return { windowStart, windowEnd };
      }
      const windowStart = timeStringToMinutes(getTime(from));
      let windowEnd = timeStringToMinutes(getTime(to));
      if (windowStart === null || windowEnd === null) return null;
      if (windowEnd < windowStart) windowEnd += 24 * 60;
      return { windowStart, windowEnd };
    };

    const now = moment().tz("Asia/Kolkata");
    const conflicts = [];

      for (const booking of bookings) {
      const classes = Array.isArray(booking?.classes) ? booking.classes : [];
      for (const cl of classes) {
        if (cl?.status === "cancelled") continue;
        if (!cl?.date) continue;

        const startMin = timeStringToMinutes(cl.startTime);
        let endMin = timeStringToMinutes(cl.endTime);
        if (startMin === null) continue;
        if (endMin === null) {
          let dur = parseInt((cl.duration || "").toString().replace(/\D/g, ""), 10);
          if (Number.isNaN(dur)) dur = 0;
          endMin = startMin + dur;
        }

        try {
          const datePart = moment(cl.date).format("YYYY-MM-DD");
          const s = cl.startTime || "00:00";
          const e = cl.endTime || null;
          const classStart = moment.tz(`${datePart}T${s}`, "YYYY-MM-DDTHH:mm", "Asia/Kolkata");
          let classEnd;
          if (e) {
            classEnd = moment.tz(`${datePart}T${e}`, "YYYY-MM-DDTHH:mm", "Asia/Kolkata");
            if (classEnd.isBefore(classStart)) classEnd = classEnd.add(1, "day");
          } else {
            let dur = parseInt((cl.duration || "").toString().replace(/\D/g, ""), 10);
            if (Number.isNaN(dur)) dur = 0;
            classEnd = classStart.clone().add(dur, "minutes");
          }
          if (classEnd.isSameOrBefore(now)) continue;
        } catch (e) {
          continue;
        }

        const window = getWindowForClass(cl);
        if (!window) continue;
        const { windowStart, windowEnd } = window;

        let bookingStart = startMin;
        let bookingEnd = endMin;
        if (bookingEnd < bookingStart) bookingEnd += 24 * 60;
        if (windowEnd >= 24 * 60 && bookingStart < windowStart) {
          bookingStart += 24 * 60;
          bookingEnd += 24 * 60;
        }

        const isOutside = bookingStart < windowStart || bookingEnd > windowEnd;
        if (isOutside) {
          conflicts.push({
            bookingId: booking?._id || booking?.id || "",
            date: moment(cl.date).tz("Asia/Kolkata").format("DD-MM-YYYY"),
            startTime: cl.startTime || "",
            endTime: cl.endTime || "",
            status: cl.status || "",
          });
        }
      }
    }

    return conflicts;
  };

  useEffect(() => {
    try {
      const conflicts = timingMode === "different" && daySchedules.length > 0
        ? computeBookingWindowConflicts(courseBookings, timeFrom, timeTo, daySchedules)
        : computeBookingWindowConflicts(courseBookings, timeFrom, timeTo);
      setBookingTimeConflicts(conflicts);
      setShowBookingTimeConflict(conflicts.length > 0);
    } catch (e) {
      setBookingTimeConflicts([]);
      setShowBookingTimeConflict(false);
    }
  }, [courseBookings, timeFrom, timeTo, timingMode, daySchedules]);

  // ### Final Save ###
  const saveHandler = async () => {
    setBtnIsLoading(true);

    const effectiveStartForCheck = timingMode === "same" ? timeFrom : daySchedules[0]?.startTime;
    if (isCourseType && startDate && effectiveStartForCheck) {
      try {
        const startDt = new Date(`${formatDateToYYYYMMDD(startDate)}T${getTime(effectiveStartForCheck)}:00`);
        if (startDt <= new Date()) {
          setBtnIsLoading(false);
          showToast(
            "Course already started",
            "This course has already started and cannot be edited.",
            "error",
            4000
          );
          return;
        }
      } catch (e) {
        // if parsing fails, continue with other validations
      }
    }

    // Calculate the effective end date for "Never" option
    let effectiveEndDate = getLastDateOfCurrentYear();
    
    if (startDate) {
      const startYear = new Date(startDate).getFullYear();
      const currentYear = new Date().getFullYear();
      if (startYear > currentYear) {
        const lastDateOfStartYear = new Date(startYear, 11, 31);
        effectiveEndDate = formatDateToYYYYMMDD(lastDateOfStartYear);
      }
    }

    // If coach has availability end date, use whichever is earlier
    if (coach?.academyAvailability?.endDate) {
      const coachEndDate = new Date(coach.academyAvailability.endDate);
      const yearEndDate = new Date(effectiveEndDate);
      effectiveEndDate = coachEndDate < yearEndDate ? formatDateToYYYYMMDD(coachEndDate) : effectiveEndDate;
    }

    let lastDateOfYear = formatDateToYYYYMMDD(effectiveEndDate);
    if (sessionType === "individual") {
      setMaximumGroupSize(1);
    }

    if (!proficiencyLevel || (Array.isArray(proficiencyLevel) ? proficiencyLevel.length === 0 : proficiencyLevel === "")) {
      setBtnIsLoading(false);
      showToast(
        "Proficiency Level Required",
        "You must select at least one proficiency level before submitting.",
        "warning"
      );
      return;
    }

    if (timingMode === "same") {
      if (!timeFrom || !timeTo) {
        if (!timeTo) setTimeToError(true);
        if (!timeFrom) setTimeFromError(true);
        setBtnIsLoading(false);
        showToast(
          "Time Required",
          "Please select both start and end time.",
          "warning"
        );
        return;
      }
      const startTime = new Date(timeFrom);
      const endTime = new Date(timeTo);
      const startMinutes = startTime.getHours() * 60 + startTime.getMinutes();
      const endMinutes = endTime.getHours() * 60 + endTime.getMinutes();
      const timeDiffInMinutes = endMinutes - startMinutes;
      if (timeDiffInMinutes < 30) {
        setBtnIsLoading(false);
        showToast(
          "Invalid Time Gap",
          "The time gap between start time and end time should be at least 30 minutes.",
          "warning"
        );
        return;
      }
    } else {
      const missing = daySchedules.some((s) => !s.startTime || !s.endTime);
      const invalidGap = daySchedules.some((s) => {
        if (!s.startTime || !s.endTime) return false;
        const startM = new Date(s.startTime).getHours() * 60 + new Date(s.startTime).getMinutes();
        const endM = new Date(s.endTime).getHours() * 60 + new Date(s.endTime).getMinutes();
        return endM - startM < 30;
      });
      if (missing || invalidGap) {
        setDaySchedulesError(true);
        setBtnIsLoading(false);
        showToast(
          "Time Required",
          "Please set start and end time for each selected day (minimum 30 minutes gap).",
          "warning"
        );
        return;
      }
    }

    const conflictsNow = timingMode === "different" && daySchedules.length > 0
      ? computeBookingWindowConflicts(courseBookings, timeFrom, timeTo, daySchedules)
      : computeBookingWindowConflicts(courseBookings, timeFrom, timeTo);
    setBookingTimeConflicts(conflictsNow);
    setShowBookingTimeConflict(conflictsNow.length > 0);

    if (conflictsNow.length > 0) {
      setBtnIsLoading(false);
      showToast(
        "Cannot reduce session time window",
        "Existing bookings fall outside the selected start/end time. Extend the time window or cancel/reschedule the affected bookings.",
        "error",
        6000
      );
      return;
    }

    if (classType === "class") {
      const enabled30 = priceFieldsEnabled.price30;
      const enabled45 = priceFieldsEnabled.price45;
      const enabled60 = priceFieldsEnabled.price60;

      const val30 = fees30 !== "";
      const val45 = fees45 !== "";
      const val60 = fees60 !== "";

      const anyFilled =
        (enabled30 && val30) ||
        (enabled45 && val45) ||
        (enabled60 && val60);

      if (!anyFilled) {
        if (enabled30) setFees30Error(true);
        if (enabled45) setFees45Error(true);
        if (enabled60) setFees60Error(true);

        showToast(
          "Price Required",
          "Please enter at least one price for the enabled durations.",
          "warning"
        );
        setBtnIsLoading(false);
        return;
      }
    }

    if (classType !== "class") {
      if (price === "") {
        setBtnIsLoading(false);
        setPriceError(true);
        showToast(
          "Price Required",
          "Please enter a price for the course.",
          "warning"
        );
        return;
      }
    }

    if (!categoryType) {
      setCategoryError(true);
      setBtnIsLoading(false);
      showToast(
        "Category Required",
        "Please select a category for the course.",
        "warning"
      );
      return;
    }

    if (!courseFacility) {
      setFacilityError(true);
      setBtnIsLoading(false);
      showToast(
        "Facility Required",
        "Please select a facility for the course.",
        "warning"
      );
      return;
    }

    if (!courseDescription || courseDescription === "<p><br></p>") {
      setCourseDescriptionError(true);
      setBtnIsLoading(false);
      showToast(
        "Description Required",
        "Please enter a description for the course.",
        "warning"
      );
      return;
    }

    if (!selectedDays.length) {
      setBtnIsLoading(false);
      setSelectedDaysError(true);
      showToast(
        "Days Required",
        "Please select at least one day for the course.",
        "warning"
      );
      return;
    }

    if (!startDate) {
      setBtnIsLoading(false);
      setStartDateError(true);
      showToast(
        "Start Date Required",
        "Please select a start date.",
        "warning"
      );
      return;
    }

    // Validate start date is not in the past
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selectedStartDate = new Date(startDate);
    selectedStartDate.setHours(0, 0, 0, 0);
    
    const initialStartDate = courseData?.dates?.startDate
      ? parseIsoToLocalDateOnly(courseData.dates.startDate)
      : null;
    const hasStartDateChanged = initialStartDate
      ? formatDateToYYYYMMDD(initialStartDate) !== formatDateToYYYYMMDD(selectedStartDate)
      : true;

    if (selectedStartDate < today && hasStartDateChanged) {
      setBtnIsLoading(false);
      setStartDateError(true);
      showToast(
        "Invalid Start Date",
        "Start date cannot be in the past.",
        "warning"
      );
      return;
    }

    if (isEnd && !endDate) {
      setBtnIsLoading(false);
      setEndDateError(true);
      showToast(
        "End Date Required",
        "Please select an end date.",
        "warning"
      );
      return;
    }

    // Validate end date is not before start date
    if (isEnd && endDate && startDate) {
      const selectedEndDate = new Date(endDate);
      const selectedStartDate = new Date(startDate);
      selectedEndDate.setHours(0, 0, 0, 0);
      selectedStartDate.setHours(0, 0, 0, 0);
      
      if (selectedEndDate < selectedStartDate) {
        setBtnIsLoading(false);
        setEndDateError(true);
        showToast(
          "Invalid End Date",
          "End date must be on or after start date.",
          "warning"
        );
        return;
      }
    }

    if (courseName.length <= 3) {
      setBtnIsLoading(false);
      setCourseNameError(true);
      showToast(
        "Invalid Course Name",
        "Course name must be at least 4 characters long.",
        "warning"
      );
      return;
    }

    if (classType === "course" && isItCamp ? !campName : false) {
      setCampNameError(true);
      setBtnIsLoading(false);
      showToast(
        "Camp Name Required",
        "Please enter a camp name.",
        "warning"
      );
      return;
    }

    // Validate maximum group size for Group sessions (allowed 1-20)
    if (sessionType === "group" && classType === "course") {
      const groupSize = Number(maximumGroupSize);
      if (!maximumGroupSize || groupSize < 1 || groupSize > 20) {
        setMaximumGroupSizeError(true);
        setBtnIsLoading(false);
        showToast(
          "Invalid Group Size",
          "Maximum group size must be between 1 and 20."
        );
        return;
      }
    }

    // Validations //
    if (!id) {
      setBtnIsLoading(true);
      toast({
        title: "Please select coach, before creating the course",
        status: "warning",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      return;
    }

    // Check if any future bookings exist on days that are no longer selected
    if (isTimeOnlyEditMode && Array.isArray(courseBookings) && courseBookings.length > 0) {
      const dayMap = {
        "Mon": "Monday",
        "Tue": "Tuesday", 
        "Wed": "Wednesday",
        "Thu": "Thursday",
        "Fri": "Friday",
        "Sat": "Saturday",
        "Sun": "Sunday"
      };
      
      const now = moment().tz("Asia/Kolkata");
      const bookingsOnRemovedDays = [];
      
      for (const booking of courseBookings) {
        const classes = Array.isArray(booking?.classes) ? booking.classes : [];
        for (const cl of classes) {
          if (cl?.status === "cancelled") continue;
          if (!cl?.date) continue;
          
          const datePart = moment(cl.date).format("YYYY-MM-DD");
          const endTime = cl.endTime || "00:00";
          const classEnd = moment.tz(`${datePart}T${endTime}`, "YYYY-MM-DDTHH:mm", "Asia/Kolkata");
          
          if (classEnd.isSameOrBefore(now)) continue;
          
          const classDate = moment(cl.date);
          const dayOfWeek = classDate.format("ddd");
          
          if (!selectedDays.includes(dayOfWeek)) {
            bookingsOnRemovedDays.push({
              date: classDate.format("DD-MM-YYYY"),
              day: dayMap[dayOfWeek] || dayOfWeek,
              time: cl.startTime
            });
          }
        }
      }
      
      if (bookingsOnRemovedDays.length > 0) {
        setBtnIsLoading(false);
        const daysList = [...new Set(bookingsOnRemovedDays.map(b => b.day))].join(", ");
        showToast(
          "Cannot remove selected days",
          `Future bookings exist on: ${daysList}. Please cancel or reschedule these bookings first.`,
          "error",
          6000
        );
        return;
      }
    }

    // Check if any future bookings exist outside the new date range
    if ((canEditTimeFields || isTimeOnlyEditMode) && Array.isArray(courseBookings) && courseBookings.length > 0) {
      const now = moment().tz("Asia/Kolkata");
      const bookingsOutsideDateRange = [];
      
      const newStartDate = moment(startDate).startOf('day');
      const newEndDate = isEnd && endDate ? moment(endDate).endOf('day') : null;
      
      for (const booking of courseBookings) {
        const classes = Array.isArray(booking?.classes) ? booking.classes : [];
        for (const cl of classes) {
          if (cl?.status === "cancelled") continue;
          if (!cl?.date) continue;
          
          const datePart = moment(cl.date).format("YYYY-MM-DD");
          const endTime = cl.endTime || "00:00";
          const classEnd = moment.tz(`${datePart}T${endTime}`, "YYYY-MM-DDTHH:mm", "Asia/Kolkata");
          
          if (classEnd.isSameOrBefore(now)) continue;
          
          const classDate = moment(cl.date).startOf('day');
          
          if (classDate.isBefore(newStartDate)) {
            bookingsOutsideDateRange.push({
              date: classDate.format("DD-MM-YYYY"),
              time: cl.startTime,
              reason: "before start date"
            });
          }
          
          if (newEndDate && classDate.isAfter(newEndDate)) {
            bookingsOutsideDateRange.push({
              date: classDate.format("DD-MM-YYYY"),
              time: cl.startTime,
              reason: "after end date"
            });
          }
        }
      }
      
      if (bookingsOutsideDateRange.length > 0) {
        setBtnIsLoading(false);
        const datesList = [...new Set(bookingsOutsideDateRange.map(b => b.date))].join(", ");
        showToast(
          "Cannot change date range",
          `Future bookings exist outside the selected date range on: ${datesList}. Please cancel or reschedule these bookings first.`,
          "error",
          6000
        );
        return;
      }
    }

    if (
      !(
        daysDifference(
          new Date(startDate),
          endDate ? new Date(endDate) : lastDateOfYear,
          selectedDays
        ) >= selectedDays.length
      )
    ) {
      setBtnIsLoading(false);
      toast({
        title: "Selected Days is not available between selected date range",
        status: "warning",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      return;
    }

    // Build startDate/endDate the same way as creation: combine date + time without UTC conversion
    const startTimeStr = timingMode === "same" ? getTime(timeFrom) : (daySchedules[0]?.startTime ? getTime(daySchedules[0].startTime) : getTime(timeFrom));
    const endTimeStr = timingMode === "same" ? getTime(timeTo) : (daySchedules[0]?.endTime ? getTime(daySchedules[0].endTime) : getTime(timeTo));
    const startDateTime = `${formatDateToYYYYMMDD(startDate)}T${startTimeStr}:00`;
    const endDateTime = isEnd
      ? `${formatDateToYYYYMMDD(endDate ? endDate : lastDateOfYear)}T${endTimeStr}:00`
      : `${lastDateOfYear}T${endTimeStr}:00`;

    let isAvailable = await getAvailableSlots(`${id}`);

    if (isAvailable !== true) {
      setBtnIsLoading(false);
      toast({
        title: "Selected slots are already booked",
        status: "warning",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      return;
    }

    const selectedUrl = categories.filter((x) => x.name === categoryType);

    const toNumberOrEmpty = (val) => {
      if (val === "" || val === null || val === undefined) return "";
      const n = Number(val);
      return Number.isFinite(n) ? n : "";
    };

    let feesPayload;
    if (classType === "class") {
      if (isTimeOnlyEditMode) {
        const existingFees = courseData?.fees || {};
        const enabled30 = !!priceFieldsEnabled.price30;
        const enabled45 = !!priceFieldsEnabled.price45;
        const enabled60 = !!priceFieldsEnabled.price60;

        const fees30Payload = enabled30 ? toNumberOrEmpty(existingFees.fees30 ?? fees30) : "";
        const fees45Payload = enabled45 ? toNumberOrEmpty(existingFees.fees45 ?? fees45) : "";
        const fees60Payload = enabled60 ? toNumberOrEmpty(existingFees.fees60 ?? fees60) : "";

        const primaryFee =
          fees30Payload !== ""
            ? fees30Payload
            : fees45Payload !== ""
            ? fees45Payload
            : fees60Payload !== ""
            ? fees60Payload
            : "";

        feesPayload = {
          feesCourse: "",
          fees30: fees30Payload,
          fees45: fees45Payload,
          fees60: fees60Payload,
          fees: primaryFee,
        };
      } else {
        const enabled30 = !!priceFieldsEnabled.price30;
        const enabled45 = !!priceFieldsEnabled.price45;
        const enabled60 = !!priceFieldsEnabled.price60;

        const fees30Payload = enabled30 ? toNumberOrEmpty(fees30) : "";
        const fees45Payload = enabled45 ? toNumberOrEmpty(fees45) : "";
        const fees60Payload = enabled60 ? toNumberOrEmpty(fees60) : "";

        const primaryFee =
          fees30Payload !== ""
            ? fees30Payload
            : fees45Payload !== ""
            ? fees45Payload
            : fees60Payload !== ""
            ? fees60Payload
            : "";

        feesPayload = {
          feesCourse: "",
          fees30: fees30Payload,
          fees45: fees45Payload,
          fees60: fees60Payload,
          fees: primaryFee,
        };
      }
    } else {
      const courseFee = toNumberOrEmpty(price);
      feesPayload = {
        feesCourse: courseFee,
        fees30: "",
        fees45: "",
        fees60: "",
        fees: courseFee,
      };
    }

    // main working body //
    let raw = JSON.stringify({
      courseId: id,
      eventId: courseData?.eventId || "",
      courseName: `${courseName.replace(/\s+/g, " ").trim()}`,
      description: `${courseDescription}`,
      images:
        selectedImages.length <= 0
          ? [{ url: selectedUrl[0]?.image }]
          : selectedImages,
      coach_id: `${courseData?.coach_id?._id}` || "",
      coachName: (coach?.firstName || "") + " " + (coach?.lastName || ""),
      category: `${categoryType}`,
      customImage: selectedImages.length <= 0 ? false : true,
      sessionType:
        classType === "course" ? `${sessionType.toLowerCase()}` : "individual",
      classType: classType,
      camp: isItCamp,
      campName: `${campName.replace(/\s+/g, " ").trim()}`,
      fees: feesPayload,
      maxGroupSize: maximumGroupSize !== "" ? maximumGroupSize : 1,
      amenitiesProvided: courseAmeneties,
      proficiency: proficiencyLevel,
      facility: facilities.find((x) => x.name === courseFacility),
      coachEmail: coach.email,
      dates: {
        startDate: startDateTime,
        endDate: endDateTime,
        startTime: timingMode === "same" ? getTime(timeFrom) : (daySchedules[0]?.startTime ? getTime(daySchedules[0].startTime) : getTime(timeFrom)),
        endTime: timingMode === "same" ? getTime(timeTo) : (daySchedules[0]?.endTime ? getTime(daySchedules[0].endTime) : getTime(timeTo)),
        days: selectedDays,
        timingMode,
        ...(timingMode === "different" && {
          daySchedules: daySchedules.map((s) => ({
            day: s.day,
            startTime: getTime(s.startTime),
            endTime: getTime(s.endTime),
          })),
        }),
      },
      ...(classType === "class" && !isEnd && { isEndDate: "never" }),
      whatYouHaveToBring: carryThings,
      cancellationPolicy: cancellationPolicy,
    });

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/course/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: raw,
    };

    axios
      .request(config)
      .then((response) => {
        toast({
          title: "Course Updated successfully",
          status: "success",
          duration: 4000,
          isClosable: true,
          position: "top",
        });
        renderMe();
        setBtnIsLoading(false);
        setCourseDescriptionError(false);
        setCourseName("");
        setCourseNameError(false);
        setCampName("");
        setCampNameError(false);
        setMaximumGroupSize(1);
        setMaximumGroupSizeError(false);
        setCourseDescription("");
        setCourseAmeneties("");
        setStartDateError(false);
        setEndDate("");
        setPriceError(false);
        setFees30("");
        setFees45("");
        setFees60("");
        setStartDate("");
        setTimeFrom("");
        setSelectedDaysError(false);
        setSelectedDays([]);
        setCancellationPolicy("");
        setCarryThings("");
        setCategoryType({});
        setCourseFacility({});
        setTimeTo("");
        setFees30Error(false);
        setFees45Error(false);
        setFees60Error(false);
        setSelectedImages([]);
        setCategoryError(false);
        setFacilityError(false);
        setBtnIsLoading(false);
        setSelectedImagesError(false);
      })
      .catch((error) => {
        setBtnIsLoading(false);
        if (
          error.response?.data?.error === "Start date cannot be in the past"
        ) {
          showToast(
            "Start date cannot be in the past",
            "Please select a future date for the course start date.",
            "error"
          );
        } else if (error.response?.status === 403) {
          showToast(
            "You don't have an access to perform this action",
            "Please contact your administrator for access.",
            "warning"
          );
        } else {
          showToast(
            error.response?.data?.error || "Something went wrong",
            error.response?.data?.message || "Please try again later.",
            "error"
          );
        }
        console.log(error);
      });
  };

  const getCategories = async () => {
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/category`
      );
      setCategories(response.data.data);
    } catch (error) {
      console.log(error);
      if (error.response?.status === 403) {
        toast({
          title: "You don't have an access to perform this action",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: error.response?.data?.error || "Something went wrong",
          description: error.response?.data?.message,
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }
    }
  };

  const getCoachDetails = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/coach/${courseData?.coach_id?._id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.error) {
          toast({
            title: response.data.error,
            status: "warning",
            duration: 4000,
            position: "top",
            isClosable: true,
          });
          navigate("/course-page");
        } else {
          const coachData = response?.data;
          setFacilities(coachData?.linkedFacilities || []);
          setCoach(coachData);
          
          if (coachData?.academyAvailability) {
            const { startTime, endTime } = coachData.academyAvailability;
            if (startTime && endTime) {
              const [sh, sm] = startTime.split(":");
              const [eh, em] = endTime.split(":");
              
              // Create proper Date objects for today's date with the specified times
              const today = new Date();
              const startTimeObj = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Number(sh), Number(sm) || 0);
              const endTimeObj = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Number(eh), Number(em) || 0);
              
              setAcademyStartTime(startTimeObj);
              setAcademyEndTime(endTimeObj);
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRadioChange = (e) => {
    const value = e.target.value === "yes";
    setIsItCamp(value);
  };

  const deleteCourse = async () => {
    try {
      let config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_BASE_URL}/api/course/${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      await axios.request(config);
      
      toast({
        title: "Course deleted successfully",
        status: "success",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      
      onDeleteClose();
      navigate("/course-page");
    } catch (error) {
      console.log(error);
      onDeleteClose();
      if (error.response?.status === 403) {
        toast({
          title: "You don't have permission to delete this course",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: "Something went wrong, please try again later",
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }
    }
  };

  const slotDateFormatter = (date) => {
    const myDate = new Date(date);
    myDate.setFullYear(2024, 11, 31);
    myDate.setHours(13, 0, 0, 0);
    return myDate.toISOString();
  };

  function convertStartDateFormat(inputDate) {
    if (!inputDate) return "";
    return moment.tz(inputDate, "Asia/Kolkata").format("YYYY-MM-DD");
  }

  function convertEndDateFormat(inputDate) {
    if (!inputDate) return "";
    return moment.tz(inputDate, "Asia/Kolkata").format("YYYY-MM-DD");
  }

  const getAvailableSlots = async (id, value, endTime) => {
    try {
      // Calculate the effective end date for "Never" option
      let effectiveEndDate = getLastDateOfCurrentYear();
      
      if (startDate) {
        const startYear = new Date(startDate).getFullYear();
        const currentYear = new Date().getFullYear();
        if (startYear > currentYear) {
          const lastDateOfStartYear = new Date(startYear, 11, 31);
          effectiveEndDate = formatDateToYYYYMMDD(lastDateOfStartYear);
        }
      }

      // If coach has availability end date, use whichever is earlier
      if (coach?.academyAvailability?.endDate) {
        const coachEndDate = new Date(coach.academyAvailability.endDate);
        const yearEndDate = new Date(effectiveEndDate);
        effectiveEndDate = coachEndDate < yearEndDate ? formatDateToYYYYMMDD(coachEndDate) : effectiveEndDate;
      }

      let lastDateOfYear = effectiveEndDate;
      const baseStartTime =
        timingMode === "different" && daySchedules[0]?.startTime
          ? getTime(daySchedules[0].startTime)
          : getTime(timeFrom);
      const baseEndTime =
        timingMode === "different" && daySchedules[0]?.endTime
          ? getTime(daySchedules[0].endTime)
          : endTime
          ? getTime(endTime)
          : getTime(timeTo);

      const buildPayloadForDays = (daysForRequest) => {
        let effectiveStartTime = baseStartTime;
        let effectiveEndTime = baseEndTime;

        if (
          timingMode === "different" &&
          daysForRequest.length === 1 &&
          daySchedules.length > 0
        ) {
          const targetDay = daysForRequest[0];
          const sched = daySchedules.find((s) => s.day === targetDay);
          if (sched?.startTime) {
            effectiveStartTime = getTime(sched.startTime);
          }
          if (sched?.endTime) {
            effectiveEndTime = getTime(sched.endTime);
          }
        }

        const startDateTime = `${convertStartDateFormat(
          startDate
        )}T${effectiveStartTime}:00`;
        const endDateTime = `${endDate ? convertEndDateFormat(endDate) : lastDateOfYear
          }T${effectiveEndTime}:00`;

        return JSON.stringify({
          dates: {
            startDate: startDateTime,
            endDate: endDateTime,
            startTime: effectiveStartTime,
            endTime: effectiveEndTime,
            days: daysForRequest,
            courseId: id,
            timingMode,
            ...(timingMode === "different" &&
              daySchedules.length > 0 && {
                daySchedules: daySchedules
                  .filter((s) => daysForRequest.includes(s.day))
                  .map((s) => ({
                    day: s.day,
                    startTime: s.startTime ? getTime(s.startTime) : "",
                    endTime: s.endTime ? getTime(s.endTime) : "",
                  })),
              }),
          },
        });
      };

      const makeRequest = (daysForRequest) =>
        axios.request({
          method: "post",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_BASE_URL}/api/course/availableSlots/${courseData?.coach_id?._id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: buildPayloadForDays(daysForRequest),
        });

      if (timingMode === "same") {
        const daysForRequest = selectedDays && selectedDays.length > 0 ? [...selectedDays] : [];
        const response = await makeRequest(daysForRequest);
        setConflictResult(response.data);
        if (response.data.message === "Slots available") {
          setShowSlotConflict(false);
          return true;
        } else {
          setShowSlotConflict(true);
          return false;
        }
      }

      if (!selectedDays || selectedDays.length <= 1) {
        const response = await makeRequest(
          selectedDays && selectedDays.length === 1 ? [selectedDays[0]] : []
        );
        setConflictResult(response.data);
        if (response.data.message === "Slots available") {
          setShowSlotConflict(false);
          return true;
        } else {
          setShowSlotConflict(true);
          return false;
        }
      }

      const responses = await Promise.allSettled(
        selectedDays.map((day) => makeRequest([day]))
      );

      const aggregatedConflicts = [];
      let anyFailure = false;
      let allAvailable = true;
      let mergedResult = null;

      responses.forEach((result) => {
        if (result.status === "fulfilled") {
          const data = result.value?.data || {};

          if (!mergedResult) {
            mergedResult = {
              ...data,
              conflictingDates: [],
            };
          }

          if (Array.isArray(data.conflictingDates)) {
            aggregatedConflicts.push(...data.conflictingDates);
          }

          if (data.message !== "Slots available") {
            allAvailable = false;
          }
        } else {
          anyFailure = true;
          allAvailable = false;
        }
      });

      if (anyFailure) {
        throw new Error(
          "Failed to fetch available slots for one or more selected days"
        );
      }

      if (!mergedResult) {
        mergedResult = {
          message: "Slots available",
          conflictingDates: [],
        };
      }

      mergedResult = {
        ...mergedResult,
        conflictingDates: aggregatedConflicts,
        message:
          aggregatedConflicts.length > 0
            ? "Conflicting slots"
            : "Slots available",
      };

      setConflictResult(mergedResult);
      setShowSlotConflict(aggregatedConflicts.length > 0);
      return aggregatedConflicts.length === 0;
    } catch (error) {
      setBtnIsLoading(false);
      toast({
        title: error.response?.data?.error || "Something went wrong",
        description: error.response?.data?.message,
        status: "error",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      return false;
    }
  };

  useEffect(() => {
    if (
      timingMode === "different" &&
      selectedDays.length > 0 &&
      startDate &&
      canEditTimeFields
    ) {
      getAvailableSlots(`${id}`);
    }
  }, [
    timingMode,
    selectedDays,
    daySchedules,
    startDate,
    endDate,
    canEditTimeFields,
    id,
  ]);

  const formatSlotDate = (date) => {
    const originalDateString = date;
    const originalDate = new Date(originalDateString);

    const year = originalDate.getUTCFullYear();
    const month = originalDate.getUTCMonth() + 1;
    const day = originalDate.getUTCDate();

    const formattedDateString = `${day}-${
      month < 10 ? "0" : ""
    }${month}-${year}`;

    return formattedDateString;
  };

  // Group conflicts with same course, date range, and time into one row (merge days)
  const groupConflictingDates = (dates) => {
    if (!Array.isArray(dates) || dates.length === 0) return [];
    const dayOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const sortDays = (arr) => [...arr].sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));
    const key = (c) =>
      `${c?.courseId ?? ""}|${c?.startDate ?? ""}|${c?.endDate ?? ""}|${c?.conflictingStartTime ?? ""}|${c?.conflictingEndTime ?? ""}`;
    const map = new Map();
    for (const c of dates) {
      const k = key(c);
      if (!map.has(k)) {
        map.set(k, { ...c, conflictingDays: sortDays(c?.conflictingDays || []) });
      } else {
        const existing = map.get(k);
        const merged = sortDays([...new Set([...(existing.conflictingDays || []), ...(c?.conflictingDays || [])])]);
        map.set(k, { ...existing, conflictingDays: merged });
      }
    }
    return Array.from(map.values());
  };

  const handleFileChange = async (e) => {
    try {
      const file = e.currentTarget.files[0];
      setSelectedImagesError(false);

      if (selectedImages.length >= 10) {
        toast({
          title: "Maximum 10 images allowed",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
        return;
      }

      if (file && file.size > 10 * 1024 * 1024) {
        toast({
          title: "Please select a file less than 10 MB.",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
        return;
      }

      const formData = new FormData();
      formData.append("image", file);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/coach/uploadImage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const url = response?.data?.url;
      if (url) {
        toast({
          title: "Image Uploaded Successfully",
          status: "success",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title:
            "Something went wrong while uploading image, please try again later",
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }

      setSelectedImages([...selectedImages, { url: url }]);
    } catch (error) {
      if (error.response?.status === 403) {
        toast({
          title: "You don't have an access to perform this action",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: error.response?.data?.error || "Something went wrong",
          description: error.response?.data?.message,
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }
    }
  };

  const deleteImageFiles = async (url, index) => {
    try {
      if (isCustomImage) {
        const formData = new FormData();
        formData.append("url", url);

        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/coach/uploadImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        toast({
          title: "Image removed Successfully",
          status: "success",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        setSelectedImages([]);
      }
    } catch (error) {
      console.log(error);
      toast({
        title:
          "Something went wrong while removing image, please try again later",
        status: "error",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      if (error.response?.status === 403) {
        toast({
          title: "You don't have an access to perform this action",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: error.response?.data?.error || "Something went wrong",
          description: error.response?.data?.message,
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }
    }
  };

  useEffect(() => {
    getCategories();
    if (courseData?.coach_id?._id) {
      getCoachDetails();
    }
    
    if (classType === "course") {
      setIsEnd(true);
    } else {
      classType === "class" && setIsEnd(true);
      let effectiveEndDate = getLastDateOfCurrentYear();
      if (coach?.academyAvailability?.endDate) {
        const coachEndDate = new Date(coach.academyAvailability.endDate);
        const yearEndDate = new Date(effectiveEndDate);
        effectiveEndDate = coachEndDate < yearEndDate ? formatDateToYYYYMMDD(coachEndDate) : effectiveEndDate;
      }

      moment.tz(endDate, "Asia/Kolkata").toISOString() ===
        moment.tz(effectiveEndDate, "Asia/Kolkata").toISOString() &&
        setIsEnd(false);
    }
  }, [courseData, classType]);

  // Close proficiency menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isProficiencyMenuOpen) {
        const proficiencyMenu = document.getElementById('proficiency-menu');
        if (proficiencyMenu && !proficiencyMenu.contains(event.target)) {
          setIsProficiencyMenuOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProficiencyMenuOpen]);

  // Initialize dates when courseData is available (ensure date-only, no timezone shift)
  useEffect(() => {
    if (courseData?.dates?.startDate) {
      setStartDate(parseIsoToLocalDateOnly(courseData.dates.startDate));
    }
    if (courseData?.dates?.endDate) {
      setEndDate(parseIsoToLocalDateOnly(courseData.dates.endDate));
    }
  }, [courseData]);

  useEffect(() => {
    if (courseData?.dates?.startTime && startDate) {
      setTimeFrom(setTimeField(startDate, courseData.dates.startTime) || "");
    }
    if (courseData?.dates?.endTime && startDate) {
      setTimeTo(setTimeField(startDate, courseData.dates.endTime) || "");
    } else if (courseData?.dates?.endTime && courseData?.dates?.startDate && !startDate) {
      setTimeTo(setTimeField(new Date(courseData.dates.startDate), courseData.dates.endTime) || "");
    }
    if (courseData?.dates?.timingMode === "different" && Array.isArray(courseData?.dates?.daySchedules) && courseData.dates.daySchedules.length > 0 && startDate) {
      const refDate = startDate instanceof Date ? startDate : new Date(courseData.dates.startDate);
      setDaySchedules(courseData.dates.daySchedules.map((s) => ({
        day: s.day,
        startTime: s.startTime ? setTimeField(refDate, s.startTime) : null,
        endTime: s.endTime ? setTimeField(refDate, s.endTime) : null,
      })));
    }
    if (courseData?.dates?.endDate) {
      setEndDate(parseIsoToLocalDateOnly(courseData.dates.endDate));
      setIsEnd(true);
    } else {
      setIsEnd(false);
    }
    if (courseData?.dates?.endDate) {
      setEndDate(parseIsoToLocalDateOnly(courseData.dates.endDate));
    }
    if (classType === "course") {
      setIsEnd(true);
    } else {
      if (courseData?.dates?.endDate) {
        setIsEnd(true);
      } else {
        setIsEnd(false);
      }
    }
  }, [courseData, startDate]);

  // Sync daySchedules with selectedDays when timingMode is "different"
  useEffect(() => {
    if (timingMode !== "different") return;
    setDaySchedules((prev) => {
      const byDay = {};
      prev.forEach((s) => { byDay[s.day] = { startTime: s.startTime, endTime: s.endTime }; });
      const next = selectedDays.map((day) => ({
        day,
        startTime: byDay[day]?.startTime ?? null,
        endTime: byDay[day]?.endTime ?? null,
      }));
      if (prev.some((p) => p.startTime && p.endTime) && next.some((n) => !n.startTime || !n.endTime) && selectedDays.every((d) => prev.some((p) => p.day === d))) {
        return prev;
      }
      return next;
    });
  }, [timingMode, selectedDays]);

  const clearFeeErrors = () => {
    setFees30Error(false);
    setFees45Error(false);
    setFees60Error(false);
  };

  return (
    <Box bgColor={"#f2f2f2"}>
      <Seo
        title={`Update Course - ${courseData?.courseName || 'Course'} | KhelSport`}
        description={`Update course details for ${courseData?.courseName || 'course'}. Manage training schedules, pricing, and course information.`}
        canonical={`https://khelcoach.com/courses/update/${id}`}
        url={`https://khelcoach.com/courses/update/${id}`}
        jsonLd={schema.course({
          name: courseData?.courseName || 'Course',
          description: courseData?.description || 'Course update page',
          url: `https://khelcoach.com/courses/update/${id}`,
          provider: {
            name: 'KhelSport',
            sameAs: ['https://khelcoach.com']
          }
        })}
      />
      <Layout title="Update Course">
        {/* Breadcrumb */}
        <Flex
          justifyContent={{ base: "flex-start", md: "space-between" }}
          alignItems={{ base: "flex-start", md: "center" }}
          mb={3}
          flexDirection={{ base: "column", md: "row" }}
          gap={{ base: 6, md: 0 }}
        >
          <Flex
            justifyContent={"flex-start"}
            alignItems={"center"}
            w={{ base: "100%", md: "auto" }}
            flexWrap="wrap"
          >
            <Button
              variant="ghost"
              size={{ base: "xs", md: "sm" }}
              leftIcon={<IoArrowBackCircleOutline fontSize={"24px"} />}
              onClick={() => navigate(-1)}
              _hover={{ bg: "gray.100" }}
              color="gray.700"
              fontWeight="bold"
              className="p-0"
            ></Button>

            <Breadcrumb fontWeight="medium" fontSize="18px">
              <BreadcrumbItem>
                <Link to="/course-page">Course</Link>
              </BreadcrumbItem>

              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink
                  href="#"
                  maxWidth={{ base: "120px", sm: "200px", md: "none" }}
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  display="inline-block"
                  title={`Details - #${id}`}
                >
                  Details
                </BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            {/* CourseName*/}
            {courseData?.courseName && (
              <Text
                ml={2}
                display="inline-block"
                maxW={{ base: "120px", sm: "200px", md: "300px" }}
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                title={courseData.courseName}
              >
                - {courseData.courseName}
              </Text>
            )}
          </Flex>
          <Flex gap={3}>
            {courseBookings.length === 0 && userData?.accessScopes?.course?.includes("delete") && (
              <Button 
                colorScheme="red" 
                variant="outline"
                onClick={onDeleteOpen}
              >
                Delete
              </Button>
            )}
            {userData?.accessScopes?.course?.includes("read") && (
              <Popover>
                <PopoverTrigger>
                  <Button colorScheme="linkedin">Coach Details</Button>
                </PopoverTrigger>
              <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton
                  color={"white"}
                  fontWeight={"semibold"}
                  mt={1}
                />
                <PopoverHeader bgColor={"#00A0DC"}>
                  <Flex>
                    <Text as={"span"} color={"white"} fontWeight={"semibold"}>
                      Coach Profile
                    </Text>
                    {/* {userData?.accessScopes?.coach?.includes("read") && ( */}
                    <Text ml={2} mt={1} fontSize={"sm"} color={"white"}>
                      <Link
                        to={`/coach-page/details/${courseData?.coach_id?._id}`}
                      >
                        <FaExternalLinkAlt />
                      </Link>
                    </Text>
                    {/* )} */}
                  </Flex>
                </PopoverHeader>
                <PopoverBody>
                  <Text m={0}>{coach?.firstName + " " + coach?.lastName}</Text>
                  <Divider my={1} />
                  <Text m={0}>{coach?.email || "n/a"}</Text>
                  <Divider my={1} />
                  <Text m={0}>{coach?.mobile || "n/a"}</Text>
                  <Divider my={1} />
                  <Text m={0}>
                    {coach?.age ? coach?.age + " Years old" : "n/a"}
                  </Text>
                  <Divider my={1} />
                  <Text m={0}>{coach?.gender?.toUpperCase() || "n/a"}</Text>
                  <Divider my={1} />
                </PopoverBody>
              </PopoverContent>
            </Popover>
            )}
          </Flex>
        </Flex>
        {classType === "course" ? (
          hasFutureBookings ? (
            <Box
              bg="red.50"
              border="1px"
              borderColor="red.200"
              borderRadius="md"
              p={4}
              mb={4}
            >
              <Text color="red.800" fontWeight="medium" textAlign={"center"}>
                You cannot edit courses having future bookings
              </Text>
            </Box>
          ) : courseStarted ? (
            <Box
              bg="red.50"
              border="1px"
              borderColor="red.200"
              borderRadius="md"
              p={4}
              mb={4}
            >
              <Text color="red.800" fontWeight="medium" textAlign={"center"}>
                You cannot edit a course after it has started
              </Text>
            </Box>
          ) : null
        ) : (
          isTimeOnlyEditMode && (
            <Box
              bg="orange.50"
              border="1px"
              borderColor="orange.200"
              borderRadius="md"
              p={4}
              mb={4}
            >
              <Text color="orange.800" fontWeight="medium" textAlign={"center"}>
                Future bookings exist: only Start Date, End Date, Days, Start Time, and End Time can be edited.
              </Text>
            </Box>
          )
        )}
        <Box
          pointerEvents={
            !canWriteCourse || isNoEditMode || (isCourseType && courseStarted) ? "none" : "auto"
          }
        >
            <Card>
              <CardBody>
                {/* Course name */}
                <FormControl isInvalid={courseNameError}>
                  <FormLabel>Training Schedule Name <Text as="span" color="red.500">*</Text></FormLabel>
                  <Input
                    type="text"
                    isReadOnly={!canEditAllFields}
                    placeholder="Enter training schedule name"
                    name="course-name"
                    id="course-name"
                    value={courseName}
                    autoComplete="off"
                    onChange={(e) => {
                      setCourseName(e.target.value);
                      if (e.target.value !== "" && e.target.value.length >= 2) {
                        setCourseNameError(false);
                      } else {
                        setCourseNameError(true);
                      }
                      if (e.target.value.length > 100) {
                        setCourseNameError(true);
                      } else {
                        setCourseNameError(false);
                      }
                      handleFormChange();
                    }}
                  />
                  {courseNameError && (
                    <FormErrorMessage>
                      Please enter training schedule name, atleast 3 characters
                      and maximum 100 characters
                    </FormErrorMessage>
                  )}
                </FormControl>
                {/* Description */}
                <FormControl mt={6} isInvalid={courseDescriptionError}>
                  <FormLabel>Description <Text as="span" color="red.500">*</Text></FormLabel>
                  <ReactQuill
                    theme="snow"
                    value={courseDescription}
                    readOnly={!canEditAllFields}
                    onChange={(value) => {
                      setCourseDescription(value);
                      if (value === "" || value === "<p><br></p>") {
                        setCourseDescriptionError(true);
                      } else {
                        setCourseDescriptionError(false);
                      }
                      handleFormChange();
                    }}
                  />

                  {courseDescriptionError && (
                    <FormErrorMessage>
                      Please enter description
                    </FormErrorMessage>
                  )}
                </FormControl>
              </CardBody>
            </Card>
            <Card
              mt={4}
              pointerEvents={
                !canEditAllFields
                  ? "none"
                  : "auto"
              }
            >
              <CardBody>
                {/* Course Image */}
                <FormControl mt={6} mb={6}>
                  <FormLabel>Course Image</FormLabel>
                  <Box mt={3}>
                    {userData?.accessScopes?.course?.includes("write") && (
                      <Input
                        id={`kycDocuments.documentImg.${0}.url`}
                        name={`kycDocuments.documentImg.${0}.url`}
                        type="file"
                        accept="image/*"
                        disabled={!canEditAllFields || selectedImages.length >= 10}
                        onChange={(e) => {
                          handleFileChange(e, 0);
                          handleFormChange();
                        }}
                        w={{ base: "100%", md: "auto" }}
                      />
                    )}
                    {selectedImages.length >= 10 && (
                      <Text color={"orange.500"} fontSize={"sm"} mt={1}>
                        Maximum 10 images allowed
                      </Text>
                    )}
                    {selectedImagesError && (
                      <Text
                        color={"red.500"}
                        fontSize={"sm"}
                        mt={1}
                        w={{ base: "100%", md: "auto" }}
                      >
                        Please select atleast one document image
                      </Text>
                    )}
                    {selectedImages.length > 0 && (
                      <Box
                        display="flex"
                        flexWrap="wrap"
                        mt={3}
                        justifyContent={{ base: "center", md: "flex-start" }}
                      >
                        {selectedImages.map((preview, index) => (
                          <Box
                            key={index}
                            m={1}
                            textAlign={"center"}
                            width={{ base: "120px", md: "140px" }}
                            height={{ base: "90px", md: "110px" }}
                            position="relative"
                            borderRadius="8px"
                            overflow="visible"
                            display="inline-block"
                          >
                            <a
                              href={`${preview?.url}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Image
                                src={preview?.url}
                                alt={`Preview ${index}`}
                                width="100%"
                                height="100%"
                                objectFit="cover"
                                borderRadius="10px"
                              />
                            </a>
                            <Button
                              colorScheme="red"
                              size="sm"
                              mt={1}
                              isDisabled={!canEditAllFields}
                              onClick={() => {
                                deleteImageFiles(preview?.url, index);
                                setSelectedImages(
                                  selectedImages.filter(
                                    (image) => image.url !== preview.url
                                  )
                                );
                                handleFormChange();
                              }}
                            >
                              Remove
                            </Button>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                </FormControl>
              </CardBody>
            </Card>

            {/*  Slot */}
            <Card
              mt={4}
              pointerEvents={
                !canWriteCourse
                  ? "none"
                  : "auto"
              }
            >
              <CardBody>
                {/* Radion btn - session type */}
                <Flex justifyContent={"center"} alignItems={"center"}>
                  <Stack direction="row">
                    {classType === "class" ? (
                      <Box mr={6}>
                        <input
                          id="notification-method-class"
                          type="radio"
                          value=""
                          required
                          checked={classType === "class"}
                          onChange={(e) =>
                            e.target.checked && setClassType("class")
                          }
                          disabled={!canEditAllFields}
                        />
                        <label
                          htmlFor="notification-method-class"
                          className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-black-300"
                          style={{
                            cursor: "pointer",
                            fontSize: "1.1rem",
                            fontWeight: "600",
                          }}
                        >
                          Session
                        </label>
                      </Box>
                    ) : (
                      <Box>
                        <input
                          id="notification-method-course"
                          type="radio"
                          value=""
                          required
                          checked={classType === "course"}
                          onChange={(e) =>
                            e.target.checked && setClassType("course")
                          }
                          disabled={!canEditAllFields}
                        />
                        <label
                          htmlFor="notification-method-course"
                          className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-black-300"
                          style={{
                            cursor: "pointer",
                            fontSize: "1.1rem",
                            fontWeight: "600",
                          }}
                        >
                          Course
                        </label>
                      </Box>
                    )}
                  </Stack>
                </Flex>
                {/* Date row: Start Date | End Date (screenshot order) */}
                {coach?.academyAvailability?.startDate && coach?.academyAvailability?.endDate && (
                  <Text fontSize="sm" color="gray.600" mb={2}>
                    Available from: {(() => {
                      const startDate = moment(coach.academyAvailability.startDate);
                      const endDate = moment(coach.academyAvailability.endDate);
                      return `${startDate.format("DD MMMM YYYY")} to ${endDate.format("DD MMMM YYYY")}`;
                    })()}
                  </Text>
                )}
                <Flex direction={{ base: "column", md: "row" }} gap={4} my={3} alignItems="flex-start">
                  <FormControl flex={1} isInvalid={startDateError}>
                    <FormLabel>Select Start Date <Text as="span" color="red.500">*</Text></FormLabel>
                    <DatePicker
                      disabled={!canEditAllFields}
                      placeholderText="Select start date"
                      className={
                        startDateError
                          ? "my-custom-datepicker dateError"
                          : "my-custom-datepicker"
                      }
                      selected={startDate}
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(date) => {
                        setEndDate("");
                        setStartDate(date);
                        if (date !== "") {
                          setStartDateError(false);
                        } else {
                          setStartDateError(true);
                        }
                        handleFormChange();
                      }}
                      minDate={dateRestrictions.minDate}
                      maxDate={dateRestrictions.maxDate}
                      dateFormat="dd MMMM yyyy"
                      filterDate={(date) => {
                        const today = new Date();
                        today.setHours(0,0,0,0);
                        return date >= today;
                      }}
                    />
                    {startDateError && (
                      <FormErrorMessage>
                        Please select start date
                      </FormErrorMessage>
                    )}
                  </FormControl>
                  <Box flex={1}>
                    {classType === "class" ? (
                      <>
                        <Flex alignItems="center" gap={4} mb={2} flexWrap={{ base: "wrap", md: "nowrap" }}>
                          <FormLabel mb={0}>End Date</FormLabel>
                          <Stack direction="row" alignItems="center">
                            <Box mr={6}>
                              <input
                                id="horizontal-list-radio-license-never"
                                type="radio"
                                required
                                value=""
                                checked={!isEnd}
                                disabled={isCoachEndDateSpecific() || !canEditTimeFields}
                                onChange={(e) => {
                                  e.target.checked ? setIsEnd(false) : setIsEnd(true);
                                  handleFormChange();
                                }}
                                name="list-radio"
                              />
                              <label
                                htmlFor="horizontal-list-radio-license-never"
                                style={{
                                  marginLeft: "8px",
                                  cursor: (isCoachEndDateSpecific() || !canEditTimeFields) ? "not-allowed" : "pointer",
                                  fontSize: "1rem",
                                  fontWeight: "600",
                                  opacity: (isCoachEndDateSpecific() || !canEditTimeFields) ? 0.5 : 1,
                                }}
                              >
                                Never
                              </label>
                            </Box>
                            <Box>
                              <input
                                id="horizontal-list-radio-license-on"
                                type="radio"
                                required
                                value=""
                                checked={isEnd}
                                onChange={(e) => {
                                  e.target.checked ? setIsEnd(true) : setIsEnd(false);
                                  handleFormChange();
                                }}
                                disabled={!canEditTimeFields}
                                name="list-radio"
                              />
                              <label
                                htmlFor="horizontal-list-radio-license-on"
                                style={{
                                  marginLeft: "8px",
                                  cursor: canEditTimeFields ? "pointer" : "not-allowed",
                                  fontSize: "1rem",
                                  fontWeight: "600",
                                  opacity: canEditTimeFields ? 1 : 0.5,
                                }}
                              >
                                On
                              </label>
                            </Box>
                          </Stack>
                          {/* {isEnd && (
                            <FormLabel mb={0} ml={2}>
                              Select End Date <Text as="span" color="red.500">*</Text>
                            </FormLabel>
                          )} */}
                        </Flex>
                        {isEnd && (
                          <DatePicker
                            placeholderText="Select end date"
                            className={
                              endDateError
                                ? "my-custom-datepicker dateError"
                                : "my-custom-datepicker"
                            }
                            selected={endDate}
                            onKeyDown={(e) => e.preventDefault()}
                            onChange={(date) => {
                              setEndDate(date);
                              if (isEnd) {
                                if (date !== "") {
                                  setEndDateError(false);
                                } else {
                                  setEndDateError(true);
                                }
                              }
                              handleFormChange();
                            }}
                            minDate={formatDateToYYYYMMDD(
                              startDate
                                ? new Date(startDate).setDate(
                                    new Date(startDate).getDate()
                                  )
                                : new Date()
                            )}
                            maxDate={dateRestrictions.maxDate}
                            dateFormat="dd MMMM yyyy"
                            disabled={!canEditTimeFields}
                          />
                        )}
                        {endDateError && isEnd && (
                          <FormErrorMessage>Select end date</FormErrorMessage>
                        )}
                      </>
                    ) : (
                      <FormControl isInvalid={endDateError}>
                        <FormLabel>Select End Date <Text as="span" color="red.500">*</Text></FormLabel>
                        <DatePicker
                          placeholderText="Select end date"
                          className={
                            endDateError
                              ? "my-custom-datepicker dateError"
                              : "my-custom-datepicker"
                          }
                          selected={endDate}
                          disabled={!canEditTimeFields}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(date) => {
                            setEndDate(date);
                            if (date !== "") {
                              setEndDateError(false);
                            } else {
                              setEndDateError(true);
                            }
                            handleFormChange();
                          }}
                          minDate={formatDateToYYYYMMDD(
                            startDate
                              ? new Date(startDate).setDate(
                                  new Date(startDate).getDate()
                                )
                              : new Date()
                          )}
                          maxDate={dateRestrictions.maxDate}
                          dateFormat="dd MMMM yyyy"
                        />
                        {endDateError && (
                          <FormErrorMessage>Select end date</FormErrorMessage>
                        )}
                      </FormControl>
                    )}
                  </Box>
                </Flex>

                {/* Weekly timing: same vs different */}
                <FormControl my={5}>
                  <FormLabel>Weekly timing <Text as="span" color="red.500">*</Text></FormLabel>
                  <RadioGroup
                    value={timingMode}
                    onChange={(value) => {
                      setTimingMode(value);
                      setDaySchedulesError(false);
                      handleFormChange();
                      if (value === "different" && selectedDays.length > 0) {
                        setDaySchedules(selectedDays.map((day) => ({
                          day,
                          startTime: timeFrom || null,
                          endTime: timeTo || null,
                        })));
                      }
                    }}
                  >
                    <Stack direction="row" spacing={4} mt={2} flexWrap="wrap">
                      <Box
                        as="label"
                        cursor="pointer"
                        borderWidth="2px"
                        borderRadius="lg"
                        borderColor={timingMode === "same" ? "blue.500" : "gray.200"}
                        bg={timingMode === "same" ? "blue.50" : "white"}
                        p={3}
                        transition="all 0.2s"
                        _hover={{ borderColor: timingMode === "same" ? "blue.500" : "gray.300" }}
                        flex="1"
                        minW="200px"
                      >
                        <Flex align="center" gap={3}>
                          <Radio value="same" colorScheme="blue" />
                          <Box>
                            <Text fontWeight="600">Same time for selected days</Text>
                            <Text fontSize="sm" color="gray.600">One time slot for all days</Text>
                          </Box>
                        </Flex>
                      </Box>
                      <Box
                        as="label"
                        cursor="pointer"
                        borderWidth="2px"
                        borderRadius="lg"
                        borderColor={timingMode === "different" ? "blue.500" : "gray.200"}
                        bg={timingMode === "different" ? "blue.50" : "white"}
                        p={3}
                        transition="all 0.2s"
                        _hover={{ borderColor: timingMode === "different" ? "blue.500" : "gray.300" }}
                        flex="1"
                        minW="200px"
                      >
                        <Flex align="center" gap={3}>
                          <Radio value="different" colorScheme="blue" />
                          <Box>
                            <Text fontWeight="600">Different time for each day</Text>
                            <Text fontSize="sm" color="gray.600">Set start/end time per day</Text>
                          </Box>
                        </Flex>
                      </Box>
                    </Stack>
                  </RadioGroup>
                </FormControl>

                {/* Select Days */}
                <FormControl my={5} isInvalid={selectedDaysError}>
                  <FormLabel>Select Days <Text as="span" color="red.500">*</Text></FormLabel>
                  {coach?.academyAvailability?.days && coach.academyAvailability.days.length > 0 && (
                    <Text fontSize="sm" color="gray.600" mb={2}>
                      Available days: {coach.academyAvailability.days.join(", ")}
                    </Text>
                  )}
                  <Flex
                    wrap="wrap"
                    justifyContent={{ base: "center", md: "flex-start" }}
                    gap={2}
                  >
                    {days.map((day, i) => {
                      const isAvailable = availableDays.includes(day);
                      return (
                        <Button
                          key={i}
                          type="button"
                          onClick={() => {
                            if (!canEditDaysFields) return;
                            if (!isAvailable) return;

                            setSelectedDays(
                              selectedDays.includes(day)
                                ? selectedDays.filter(
                                    (selected) => selected !== day
                                  )
                                : [...selectedDays, day]
                            );
                            if (!day) {
                              setSelectedDaysError(true);
                            } else {
                              setSelectedDaysError(false);
                            }
                            handleFormChange();
                          }}
                          colorScheme={
                            selectedDays.includes(day) ? "telegram" : "gray"
                          }
                          minW="60px"
                          isDisabled={!canEditDaysFields || !isAvailable}
                          opacity={isAvailable ? 1 : 0.4}
                          cursor={isAvailable ? "pointer" : "not-allowed"}
                          _hover={isAvailable ? {} : { bg: "gray.200" }}
                        >
                          {day}
                        </Button>
                      );
                    })}
                  </Flex>
                  {selectedDaysError && (
                    <FormErrorMessage>Select the Days</FormErrorMessage>
                  )}
                </FormControl>
                <Divider />

                {/* Start Time && End time (same) OR Time for each day (different) */}
                {coach?.academyAvailability?.startTime && coach?.academyAvailability?.endTime && (
                  <Text fontSize="sm" color="gray.600" mb={2}>
                    Available start time: {(() => {
                      const time = coach.academyAvailability.startTime;
                      const [hours, minutes] = time.split(':');
                      const hour12 = hours % 12 || 12;
                      const ampm = hours >= 12 ? 'PM' : 'AM';
                      return `${hour12}:${minutes} ${ampm}`;
                    })()} & Available end time: {(() => {
                      const time = coach.academyAvailability.endTime;
                      const [hours, minutes] = time.split(':');
                      const hour12 = hours % 12 || 12;
                      const ampm = hours >= 12 ? 'PM' : 'AM';
                      return `${hour12}:${minutes} ${ampm}`;
                    })()}
                  </Text>
                )}
                {timingMode === "same" && (
                  <Flex direction={{ base: "column", md: "row" }} alignItems={{ base: "stretch", md: "flex-start" }} gap={4} my={3} flexWrap="nowrap">
                    <FormControl
                      flex={{ base: "none", md: 1 }}
                      minW={{ md: 0 }}
                      isInvalid={timeFromError}
                    >
                      <FormLabel>Start Time 
                        <Text as="span" fontSize="sm"> (IST)</Text>
                        <Text as="span" color="red.500">*</Text>
                      </FormLabel>
                      <DatePicker
                        selected={timeFrom}
                        className={
                          timeFromError
                            ? "my-custom-datepicker dateError"
                            : "my-custom-datepicker"
                        }
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={async (value) => {
                          if (value === "") {
                            setTimeFromError(true);
                          } else {
                            setTimeFromError(false);
                          }
                          setTimeFrom(value);
                          setTimeTo("");
                          handleFormChange();
                        }}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        placeholderText="Select time"
                        disabled={!canEditTimeFields || isNoEditMode || startDate === ""}
                        filterTime={filterTimeForStart}
                        timeClassName={(time) =>
                          filterTimeForStart(time) ? "enabled-time" : "disabled-time"
                        }
                      />
                      {timeFromError && (
                        <FormErrorMessage>Select start time</FormErrorMessage>
                      )}
                    </FormControl>
                    <FormControl flex={{ base: "none", md: 1 }} minW={{ md: 0 }} isInvalid={timeToError}>
                      <FormLabel>End Time 
                        <Text as="span" fontSize="sm"> (IST)</Text>
                        <Text as="span" color="red.500">*</Text>
                      </FormLabel>
                      <DatePicker
                        selected={timeTo}
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={async (value) => {
                          await getAvailableSlots(`${id}`, "", value);
                          setTimeTo(value);
                          if (value === "") {
                            setTimeToError(true);
                          } else {
                            setTimeToError(false);
                          }
                          handleFormChange();
                        }}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        className={
                          timeToError
                            ? "my-custom-datepicker dateError"
                            : "my-custom-datepicker"
                        }
                        placeholderText="Select time"
                        disabled={!canEditTimeFields || isNoEditMode || timeFrom === ""}
                        filterTime={filterTimeForEnd}
                        timeClassName={(time) =>
                          filterTimeForEnd(time) ? "enabled-time" : "disabled-time"
                        }
                      />
                      {timeToError && (
                        <FormErrorMessage>Select end time</FormErrorMessage>
                      )}
                    </FormControl>
                  </Flex>
                )}

                {timingMode === "different" && selectedDays.length > 0 && (
                  <FormControl my={4} isInvalid={daySchedulesError}>
                    <FormLabel>Time for each selected day (IST) <Text as="span" color="red.500">*</Text></FormLabel>
                    <VStack align="stretch" spacing={3} mt={2}>
                      {daySchedules.map((schedule) => (
                        <Flex
                          key={schedule.day}
                          direction={{ base: "column", sm: "row" }}
                          align={{ base: "stretch", sm: "center" }}
                          gap={3}
                          p={3}
                          borderRadius="md"
                          bg="gray.50"
                          borderWidth="1px"
                          borderColor="gray.200"
                        >
                          <Text fontWeight="600" minW="44px" color="blue.600">{schedule.day}</Text>
                          <Flex flex={1} gap={2} wrap="wrap">
                            <Box flex="1" minW="120px" position="relative" className="datepicker-time-wrapper">
                              <Text fontSize="xs" color="gray.600" mb={1}>Start</Text>
                              <DatePicker
                                key={`${schedule.day}-start`}
                                selected={schedule.startTime}
                                onChange={(value) => {
                                  setDaySchedules((prev) =>
                                    prev.map((s) =>
                                      s.day === schedule.day
                                        ? {
                                            ...s,
                                            startTime: value,
                                            // reset endTime so user must pick a new one
                                            endTime: null,
                                          }
                                        : s
                                    )
                                  );
                                  setDaySchedulesError(false);
                                  handleFormChange();
                                }}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                dateFormat="h:mm aa"
                                placeholderText="Select time"
                                className="my-custom-datepicker"
                                onKeyDown={(e) => e.preventDefault()}
                                disabled={!canEditTimeFields || isNoEditMode}
                                filterTime={(time) => filterTimeForStartPerDay(schedule, time)}
                                timeClassName={(time) =>
                                  filterTimeForStartPerDay(schedule, time) ? "enabled-time" : "disabled-time"
                                }
                                popperClassName="datepicker-popper-inline"
                              />
                            </Box>
                            <Box flex="1" minW="120px" position="relative" className="datepicker-time-wrapper">
                              <Text fontSize="xs" color="gray.600" mb={1}>End</Text>
                              <DatePicker
                                key={`${schedule.day}-end`}
                                selected={schedule.endTime}
                                onChange={(value) => {
                                  setDaySchedules((prev) =>
                                    prev.map((s) =>
                                      s.day === schedule.day ? { ...s, endTime: value } : s
                                    )
                                  );
                                  setDaySchedulesError(false);
                                  handleFormChange();
                                }}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                dateFormat="h:mm aa"
                                placeholderText="Select time"
                                className="my-custom-datepicker"
                                onKeyDown={(e) => e.preventDefault()}
                                disabled={!canEditTimeFields || isNoEditMode || !schedule.startTime}
                                filterTime={(time) => {
                                  if (!schedule.startTime) return true;
                                  const startM = new Date(schedule.startTime).getHours() * 60 + new Date(schedule.startTime).getMinutes();
                                  const selectedM = new Date(time).getHours() * 60 + new Date(time).getMinutes();
                                  if (selectedM - startM < 30) return false;
                                  if (academyStartTime && academyEndTime) {
                                    const aStart = academyStartTime.getHours() * 60 + academyStartTime.getMinutes();
                                    const aEnd = academyEndTime.getHours() * 60 + academyEndTime.getMinutes();
                                    return selectedM >= aStart && selectedM <= aEnd;
                                  }
                                  return true;
                                }}
                                timeClassName={() => "enabled-time"}
                                popperClassName="datepicker-popper-inline"
                              />
                            </Box>
                          </Flex>
                        </Flex>
                      ))}
                    </VStack>
                    {daySchedulesError && (
                      <FormErrorMessage>
                        Please set start and end time for each selected day (min 30 min gap).
                      </FormErrorMessage>
                    )}
                  </FormControl>
                )}

                {timingMode === "different" && selectedDays.length === 0 && (
                  <Text fontSize="sm" color="gray.500" my={2}>
                    Select days above to set time for each day.
                  </Text>
                )}

                {/* Conflicting Dates */}
                {showSlotConflict && (
                  <Box my={4}>
                    <Flex
                      justifyContent={"center"}
                      alignItems={"center"}
                      mb={2}
                    >
                      <Text
                        color={"red.500"}
                        fontSize={"lg"}
                        fontWeight={"semibold"}
                      >
                        Conflicting Courses
                      </Text>
                    </Flex>
                    <TableContainer>
                      <Table variant="simple">
                        <Thead
                          bgColor={"#c1eaee"}
                          position={"sticky"}
                          top={"0px"}
                        >
                          <Tr bgColor={"red.100"}>
                            <Th>Course Id</Th>
                            <Th>Start Date</Th>
                            <Th>End Date</Th>
                            <Th>Start Time</Th>
                            <Th>End Time</Th>
                            <Th>Days</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {groupConflictingDates(conflictResult?.conflictingDates ?? []).map(
                            (conflictDate, inx) => {
                              return (
                                <Tr bgColor={"gray.50"} key={inx}>
                                  <Td>{conflictDate?.courseId}</Td>
                                  <Td>
                                    {formatSlotDate(conflictDate?.startDate)}
                                  </Td>
                                  <Td>
                                    {formatSlotDate(conflictDate?.endDate)}
                                  </Td>
                                  <Td>{conflictDate?.conflictingStartTime}</Td>
                                  <Td>{conflictDate?.conflictingEndTime}</Td>
                                  <Td>
                                    <UnorderedList>
                                      {conflictDate?.conflictingDays?.map(
                                        (days, i) => {
                                          return (
                                            <ListItem key={i}>{days}</ListItem>
                                          );
                                        }
                                      )}
                                    </UnorderedList>
                                  </Td>
                                </Tr>
                              );
                            }
                          )}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}

                {showBookingTimeConflict && (
                  <Box my={4}>
                    <Flex justifyContent={"center"} alignItems={"center"} mb={2}>
                      <Text color={"red.500"} fontSize={"lg"} fontWeight={"semibold"}>
                        Conflicting Bookings
                      </Text>
                    </Flex>
                    <TableContainer>
                      <Table variant="simple">
                        <Thead bgColor={"#c1eaee"} position={"sticky"} top={"0px"}>
                          <Tr bgColor={"red.100"}>
                            <Th>Booking Id</Th>
                            <Th>Date</Th>
                            <Th>Start Time</Th>
                            <Th>End Time</Th>
                            <Th>Status</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {bookingTimeConflicts.map((b, inx) => (
                            <Tr bgColor={"gray.50"} key={inx}>
                              <Td>{b?.bookingId}</Td>
                              <Td>{b?.date}</Td>
                              <Td>{b?.startTime}</Td>
                              <Td>{b?.endTime}</Td>
                              <Td>{b?.status}</Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
                {/* price */}
                {classType === "class" ? (
                  <>
                    <Flex
                      direction={{ base: "column", md: "row" }}
                      gap={4}
                      justifyContent={{ md: "space-between" }}
                      alignItems={{ md: "center" }}
                    >
                      <FormControl
                        my={4}
                        flexBasis={"31%"}
                        isInvalid={fees30Error}
                      >
                        <FormLabel>
                          Price <span>(30 minutes)</span>
                        </FormLabel>
                        <Tooltip
                          label={
                            !priceFieldsEnabled.price30
                              ? !timeTo
                                ? "Select end time to enable 30-min price"
                                : "Duration must be at least 30 minutes to enable this price"
                              : ""
                          }
                          hasArrow
                          isDisabled={priceFieldsEnabled.price30}
                        >
                          <Input
                            type="number"
                            name="price"
                            id="price"
                            placeholder="₹0.00"
                            value={fees30}
                            autoComplete="off"
                            isDisabled={!canEditAllFields || !priceFieldsEnabled.price30}
                            onChange={(e) => {
                              let newValue = e.target.value;
                              newValue = newValue.replace(/[^\d.]/g, "");
                              newValue = newValue.replace(/^0+/, "");
                              newValue = newValue.replace(/^\./, "");
                              if (newValue.includes(".")) {
                                newValue = newValue.split(".")[0];
                              }
                              setFees30(newValue);
                              feeCacheRef.current.fees30 = newValue;
                              clearFeeErrors();
                              handleFormChange();
                            }}
                        />
                        </Tooltip>
                        {fees30Error && (
                          <FormErrorMessage>
                            Please enter the price
                          </FormErrorMessage>
                        )}
                      </FormControl>

                      <FormControl
                        my={4}
                        flexBasis={"31%"}
                        isInvalid={fees45Error}
                      >
                        <FormLabel>
                          Price <span>(45 minutes)</span>
                        </FormLabel>
                        <Tooltip
                          label={
                            !priceFieldsEnabled.price45
                              ? !timeTo
                                ? "Select end time to enable 45-min price"
                                : "Duration must be at least 45 minutes to enable this price"
                              : ""
                          }
                          hasArrow
                          isDisabled={priceFieldsEnabled.price45}
                        >
                          <Input
                            type="number"
                            name="price"
                            id="price"
                            placeholder="₹0.00"
                            value={fees45}
                            autoComplete="off"
                            isDisabled={!canEditAllFields || !priceFieldsEnabled.price45}
                            onChange={(e) => {
                              let newValue = e.target.value;
                              newValue = newValue.replace(/[^\d.]/g, "");
                              newValue = newValue.replace(/^0+/, "");
                              newValue = newValue.replace(/^\./, "");
                              if (newValue.includes(".")) {
                                newValue = newValue.split(".")[0];
                              }
                              setFees45(newValue);
                              feeCacheRef.current.fees45 = newValue;
                              clearFeeErrors();
                              handleFormChange();
                            }}
                        />
                        </Tooltip>
                        {fees45Error && (
                          <FormErrorMessage>
                            Please enter the price
                          </FormErrorMessage>
                        )}
                      </FormControl>

                      <FormControl
                        my={4}
                        flexBasis={"31%"}
                        isInvalid={fees60Error}
                      >
                        <FormLabel>
                          Price <span>(60 minutes)</span>
                        </FormLabel>
                        <Tooltip
                          label={
                            !priceFieldsEnabled.price60
                              ? !timeTo
                                ? "Select end time to enable 60-min price"
                                : "Duration must be at least 60 minutes to enable this price"
                              : ""
                          }
                          hasArrow
                          isDisabled={priceFieldsEnabled.price60}
                        >
                          <Input
                            type="number"
                            name="price"
                            id="price"
                            placeholder="₹0.00"
                            value={fees60}
                            autoComplete="off"
                            isDisabled={!canEditAllFields || !priceFieldsEnabled.price60}
                            onChange={(e) => {
                              let newValue = e.target.value;
                              newValue = newValue.replace(/[^\d.]/g, "");
                              newValue = newValue.replace(/^0+/, "");
                              newValue = newValue.replace(/^\./, "");
                              if (newValue.includes(".")) {
                                newValue = newValue.split(".")[0];
                              }
                              setFees60(newValue);
                              feeCacheRef.current.fees60 = newValue;
                              clearFeeErrors();
                              handleFormChange();
                            }}
                        />
                        </Tooltip>
                        {fees60Error && (
                          <FormErrorMessage>
                            Please enter the price
                          </FormErrorMessage>
                        )}
                      </FormControl>
                    </Flex>
                  </>
                ) : (
                  <FormControl my={4} isInvalid={priceError}>
                    <FormLabel>Price <Text as="span" color="red.500">*</Text></FormLabel>
                    <Tooltip
                      label={
                        !priceFieldsEnabled.coursePrice
                          ? !timeTo
                            ? "Select end time to enable price"
                            : "Duration must be at least 30 minutes to enable price"
                          : ""
                      }
                      hasArrow
                      isDisabled={priceFieldsEnabled.coursePrice}
                    >
                      <Input
                        type="number"
                        name="price"
                        id="price"
                        placeholder="₹0.00"
                        value={price}
                        autoComplete="off"
                        isDisabled={!canEditAllFields || !priceFieldsEnabled.coursePrice}
                        onChange={(e) => {
                          setPrice(e.target.value);
                          feeCacheRef.current.price = e.target.value;
                          if (e.target.value !== "") {
                            setPriceError(false);
                          } else {
                            setPriceError(true);
                          }
                          handleFormChange();
                        }}
                      />
                    </Tooltip>
                    {priceError && (
                      <FormErrorMessage>
                        Please enter the price
                      </FormErrorMessage>
                    )}
                  </FormControl>
                )}
              </CardBody>
            </Card>
            <Card
              mt={4}
              pointerEvents={
                !canEditAllFields
                  ? "none"
                  : "auto"
              }
            >
              <CardBody>
                {/* Session type if -- Course */}
                {classType === "course" && (
                  <FormControl mt={6}>
                    <FormLabel>Session Type</FormLabel>
                    <Select
                      value={sessionType}
                      isDisabled={!canEditAllFields}
                      onChange={(e) => {
                        setSessionType(e.target.value);
                        setMaximumGroupSize(1);
                        handleFormChange();
                      }}
                    >
                      <option value="group">Group</option>
                      <option value="individual">Individual</option>
                    </Select>
                  </FormControl>
                )}

                {/* Is it a camp if --- Course */}
                {classType !== "class" && (
                  <>
                    <Flex
                      justifyContent={"flex-start"}
                      alignItems={"center"}
                      mt={4}
                      mb={2}
                    >
                      <Text
                        fontWeight={"semibold"}
                        fontSize={"16px"}
                        mb={1}
                        mr={4}
                      >
                        Is it a camp ?{" "}
                      </Text>
                      <Box mr={4}>
                        <input
                          type="radio"
                          id="yes"
                          name="camp-type"
                          value="yes"
                          disabled={!canEditAllFields}
                          onChange={(e) => {
                            handleRadioChange(e);
                            handleFormChange();
                          }}
                          style={{ marginTop: "2px" }}
                        />
                        <label
                          htmlFor="yes"
                          style={{ marginLeft: "8px", cursor: "pointer" }}
                        >
                          Yes
                        </label>
                      </Box>
                      <Box>
                        <input
                          type="radio"
                          id="no"
                          name="camp-type"
                          value="no"
                          disabled={!canEditAllFields}
                          onChange={(e) => {
                            handleRadioChange(e);
                            handleFormChange();
                          }}
                          defaultChecked
                          style={{ marginTop: "2px" }}
                        />
                        <label
                          htmlFor="no"
                          style={{ marginLeft: "8px", cursor: "pointer" }}
                        >
                          No
                        </label>
                      </Box>
                    </Flex>
                    {isItCamp && (
                      <Box>
                        <Input
                          type="text"
                          name="camp-name"
                          id="camp-name"
                          value={campName}
                          isReadOnly={!canEditAllFields}
                          autoComplete="off"
                          placeholder="Enter camp name"
                          onChange={(e) => {
                            setCampName(e.target.value);
                            if (e.target.value !== "") {
                              setCampNameError(false);
                            } else {
                              setCampNameError(true);
                            }
                            if (
                              e.target.value.length > 100 ||
                              e.target.value.length < 3
                            ) {
                              setCampNameError(true);
                            } else {
                              setCampNameError(false);
                            }
                            handleFormChange();
                          }}
                        />
                        {campNameError && (
                          <FormErrorMessage>
                            Please enter camp name characters must be greater
                            than or equal to 3 and less than equal to 100
                          </FormErrorMessage>
                        )}
                      </Box>
                    )}
                  </>
                )}

                {/* Category */}
                <FormControl mt={6} isInvalid={categoryError}>
                  <FormLabel>Category <Text as="span" color="red.500">*</Text></FormLabel>
                  <Select
                    placeholder="Select Category"
                    value={categoryType}
                    isDisabled={!canEditAllFields}
                    onChange={(e) => {
                      setCategoryType(e.target.value);
                      setCategoryError(false);
                      handleFormChange();
                    }}
                  >
                    {categories?.map((category, inx) => (
                      <option key={inx} value={category?.name}>
                        {category?.name}
                      </option>
                    ))}
                  </Select>
                  {categoryError && (
                    <FormErrorMessage>Please select category</FormErrorMessage>
                  )}
                </FormControl>
                {/* Select Facility */}
                <FormControl mt={6} isInvalid={facilityError}>
                  <FormLabel>Facility <Text as="span" color="red.500">*</Text></FormLabel>
                  <Select
                    placeholder="Select Facility"
                    value={courseFacility}
                    isDisabled={!canEditAllFields}
                    onChange={(e) => {
                      setCourseFacility(e?.target?.value);
                      setFacilityError(false);
                      setCourseAmeneties(
                        facilities.filter((x) => x.name === e.target.value)[0]
                          .amenities
                      );
                      handleFormChange();
                    }}
                  >
                    {facilities.map((facility, inx) => (
                      <option key={inx} value={facility.name}>
                        {facility.name}
                      </option>
                    ))}
                  </Select>
                  {facilityError && (
                    <FormErrorMessage>Please select facility</FormErrorMessage>
                  )}
                </FormControl>

                {/* Max group size */}
                {sessionType === "group" && classType === "course" && (
                  <FormControl mt={6} isInvalid={maximumGroupSizeError}>
                    <FormLabel>Maximum Group Size (1-20)</FormLabel>
                    <Input
                      type="number"
                      placeholder="Enter maximum group size (1-20)"
                      name="max-group-size"
                      id="max-group-size"
                      value={maximumGroupSize}
                      min="1"
                      max="20"
                      isReadOnly={!canEditAllFields}
                      onChange={(e) => {
                        const raw = e.target.value || "";
                        const digits = raw.replace(/\D/g, "");

                        if (digits === "") {
                          setMaximumGroupSize("");
                          setMaximumGroupSizeError(true);
                          return;
                        }

                        const numValue = parseInt(digits, 10);
                        if (isNaN(numValue)) return;

                        if (numValue < 1) {
                          setMaximumGroupSize(1);
                          setMaximumGroupSizeError(false);
                        } else if (numValue > 20) {
                          setMaximumGroupSize(20);
                          setMaximumGroupSizeError(false);
                        } else {
                          setMaximumGroupSize(numValue);
                          setMaximumGroupSizeError(false);
                        }
                      }}
                      onBlur={(e) => {
                        // Ensure value is set to 1 if empty on blur
                        if (e.target.value === "" || parseInt(e.target.value, 10) < 1) {
                          setMaximumGroupSize(1);
                          setMaximumGroupSizeError(false);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === '+' || e.key === '-' || e.key === '.' || e.key === 'e' || e.key === 'E') {
                          e.preventDefault();
                          return;
                        }
                        if (e.key === '0' && e.target.value === '') {
                          e.preventDefault();
                          return;
                        }
                        const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab'];
                        if (allowed.includes(e.key)) return;
                        if (!/^[0-9]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                      {maximumGroupSizeError && (
                      <FormErrorMessage>
                        Please enter maximum group size between 1 and 20
                      </FormErrorMessage>
                    )}
                  </FormControl>
                )}
                {/* Proficiency Level */}
                <FormControl mt={6}>
                  <FormLabel>Proficiency Level <Text as="span" color="red.500">*</Text></FormLabel>
                  <Box position="relative" id="proficiency-menu">
                    <Button
                      w={"100%"}
                      rightIcon={<FaChevronDown />}
                      isDisabled={!canEditAllFields}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsProficiencyMenuOpen(!isProficiencyMenuOpen);
                      }}
                    >
                      {proficiencyLevel.length > 0
                        ? `${proficiencyLevel.length} selected`
                        : "Select Proficiency Level(s)"}
                    </Button>
                    
                    {isProficiencyMenuOpen && (
                      <Box
                        position="absolute"
                        top="100%"
                        left={0}
                        right={0}
                        bg="white"
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="md"
                        boxShadow="lg"
                        zIndex={1000}
                        mt={1}
                        minW={window.innerWidth - 600 + "px"}
                      >
                        <Box p={2}>
                          {proficiencyLevelOption?.map((proficiency, i) => (
                            <Box p={2} key={i}>
                              <Checkbox
                                size="md"
                                colorScheme="green"
                                value={proficiency.value}
                                isChecked={proficiencyLevel.includes(proficiency.value)}
                                onChange={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const isChecked = e.target.checked;
                                  const value = proficiency.value;
                                  
                                  if (isChecked) {
                                    // Add to proficiency level if not already present
                                    if (!proficiencyLevel.includes(value)) {
                                      const newLevels = [...proficiencyLevel, value];
                                      setProficiencyLevel(newLevels);
                                      handleFormChange();
                                    }
                                  } else {
                                    // Remove from proficiency level
                                    const newLevels = proficiencyLevel.filter(level => level !== value);
                                    setProficiencyLevel(newLevels);
                                    handleFormChange();
                                  }
                                }}
                              >
                                {proficiency.name}
                              </Checkbox>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    )}
                  </Box>

                  <HStack spacing={4} mt={2} flexWrap="wrap">
                    {proficiencyLevel && proficiencyLevel.length > 0 &&
                      proficiencyLevel.map((level, index) => {
                        const levelOption = proficiencyLevelOption.find(opt => opt.value === level);
                        return (
                          <Tag
                            key={index}
                            size={"md"}
                            variant="solid"
                            colorScheme="teal"
                            mb={1}
                          >
                            {levelOption?.name || level}
                          </Tag>
                        );
                      })
                    }
                  </HStack>

                </FormControl>
                {/* Ameneties */}
                <FormControl mt={6}>
                  <FormLabel>Ameneties</FormLabel>
                  <ReactQuill
                    theme="snow"
                    value={courseAmeneties}
                    readOnly={!canEditAllFields}
                    onChange={(value) => {
                      setCourseAmeneties(value);
                      handleFormChange();
                    }}
                  />
                </FormControl>
                {/* Thing Have to Carry with */}
                <FormControl mt={6}>
                  <FormLabel>Thing Have to Carry with</FormLabel>
                  <ReactQuill
                    theme="snow"
                    value={carryThings}
                    readOnly={!canEditAllFields}
                    onChange={(value) => {
                      setCarryThings(value);
                      handleFormChange();
                    }}
                  />
                </FormControl>
                {/* Cancellation Policy */}
                <FormControl mt={6}>
                  <FormLabel>Cancellation Policy</FormLabel>
                  <ReactQuill
                    theme="snow"
                    value={cancellationPolicy}
                    readOnly={!canEditAllFields}
                    onChange={(value) => {
                      setCancellationPolicy(value);
                      handleFormChange();
                    }}
                  />
                </FormControl>
              </CardBody>
            </Card>
            {canWriteCourse && !isNoEditMode && (!isCourseType || !courseStarted) && (
              <Flex
                mt={4}
                direction={{ base: "column", md: "row" }}
                gap={4}
                justifyContent={{ md: "space-between" }}
                alignItems={{ md: "center" }}
              >
                <Button
                  variant={"solid"}
                  colorScheme="red"
                  size={"sm"}
                  px={8}
                  flexBasis={{ md: "49%" }}
                  isDisabled={isDiscardDisabled || !formChanged}
                  onClick={onOpen}
                  w={{ base: "100%", md: "auto" }}
                >
                  Discard
                </Button>
                <Button
                  variant={"solid"}
                  colorScheme="green"
                  size={"sm"}
                  px={8}
                  isLoading={btnIsLoading}
                  onClick={saveHandler}
                  flexBasis={{ md: "49%" }}
                  w={{ base: "100%", md: "auto" }}
                >
                  Update
                </Button>
              </Flex>
            )}

          <AlertDialog isOpen={isOpen} onClose={onClose}>
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  Discard Changes
                </AlertDialogHeader>

                <AlertDialogBody isCentered>
                  Are you sure? You can't undo this action afterwards.
                </AlertDialogBody>

                <AlertDialogFooter>
                  <Button onClick={onClose}>No</Button>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      onClose();
                      setIsDiscardDisabled(true);
                      setFormChanged(false);
                      renderMe();
                    }}
                    ml={3}
                  >
                    Yes
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>

          {/* Delete Confirmation Dialog */}
          <AlertDialog isOpen={isDeleteOpen} onClose={onDeleteClose} isCentered>
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  Delete Course
                </AlertDialogHeader>

                <AlertDialogBody>
                  Are you sure you want to delete this course/session? This action cannot be undone.
                </AlertDialogBody>

                <AlertDialogFooter>
                  <Button onClick={onDeleteClose}>
                    Cancel
                  </Button>
                  <Button
                    colorScheme="red"
                    onClick={deleteCourse}
                    ml={3}
                  >
                    Delete
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </Box>
      </Layout>
    </Box>
  );
};

export default CourseUpdate;
